import { GETPROPERTY_LIST, GET_LANDING_EXPLORATION } from "./PropertyListQueries";
import { GET_MY_CART_ITEMS } from "./cartQueries";
import { CREATE_PAYMENT_METHOD } from "./payment";
import { CREATE_PAYMENT_INTENT } from "./Mutations";
import {
    EXPLORE_PROPERTY_BUTTON,
    MY_CAMPAIGN_LIST_QUERY,
    CONTENT_HUB_QUERY,
    DELIVERY_REPORTS_QUERY,
    INVOICE,
    CART_PAGE_ITEM,
    PROPERTY_DETAILS,
    PROPERTY_DETAILS_CHART_QUERY,
    PROOF_OF_PLAY,
    PROOF_OF_PLAY_ASSERTS,
    ASSIGN_CREATIVES_ITEM_QUERY,
    GET_ASSIGNED_CONTENT,
    GET_ASSIGN_ECOMMERCE_ASSETS,
    EDIT_CAMPAIGN,
    NEGOTIATE_CAMPAIGN_QUERY,
    Get_Country_Code,
    Get_Currency_Code_Details,
    USER_ACCOUNT_QUERY,
    AUTHENTICATE_MUTATION,
    Get_ThreeBillboard,
    GALLERY_IMAGE_ASSETS_QUERY,
    PROPERTY_LIST_VENUE_TYPE_LIST,
    GET_STATE_LIST,
    GET_DISTRICT_LIST,
    COMPANY_PAYMENT_OPTIONS,
    PAYMENT_TRANSACTION_DETAILS,
    GET_OFFLINE_PAYMENT_INVOICE,
    OFFLINE_PAYMENT_UPLOAD_MUTATION,
    REGISTER_MUTATION,
    COUPONS_MUTATION,
    Media_Id,
    EXPLORE_PROPERTY_VENUE_TYPE_LIST,
    GET_COUNTRY_LIST,
    GET_MARKETPLACE_COUNTRIES,
    GET_COUNTRY_BY_IP,
    FORGET_PASSWORD,
    MYCAMPAIGN_LIST,
    GET_CAMPAIGNS,
    DELETE_CART_PAGE,
    REQUEST_FOR_APPROVAL,
    MY_CART_ITEM_LIST,
    ACCOUNT,
    GET_PROPERTY_DETAILS,
    CONTACT_US_MUTATION,
    UPLOAD_CONTENT_MUTATION,
    DELETE_CONTENT_MUTATION,
    ASSIGNED_CONTENT_COUNT,
    ASSIGNED_ASSETS_TOCAMPAIGN,
    NEGOTIATE_CAMPAIGN_SEND_REQUEST,
    CHANGE_PASSWORD,
    UPDATE_PROFILE_MUTATION,
    CART_INITIAL_QUERY,
    CREATE_CHECKOUT_SESSION,
    UPDATESTATUSMUTATION,
    SUBMIT_ENQUIRY,
    CHATBOT_ANSWER,
    COUNTRY_CODE_LIST,
    GET_DAILY_DELIVERY_REPORT,
    GET_DETAILED_DELIVERY_REPORT,
    MEDIA_OWNER_FILTER,
    COMPANY_LIST,
    ECOMMERCE_CONFIG,
    GET_STATE_LIST_MARKETPLACE,
    GET_DISTRICT_LIST_MARKETPLACE,
} from "./Queries";
import { faker } from "@faker-js/faker";

const timeZones = [
    'America/New_York', 'Europe/London', 'Asia/Tokyo', 'Australia/Sydney', 'America/Los_Angeles'
];

const getRandomElement = (array: any) => {
    return array[Math.floor(Math.random() * array.length)];
};

const sampleImages = [
    'static/mockbillboard/sample1.jpg',
    'static/mockbillboard/sample2.jpg',
    'static/mockbillboard/sample3.png',
    'static/mockbillboard/sample4.webp',
    'static/mockbillboard/sample5.webp',
    'static/mockbillboard/sample6.webp',
    'static/mockbillboard/sample7.jpg',
    'static/mockbillboard/sample8.webp',
    'static/mockbillboard/sample9.jpg',
    'static/mockbillboard/sample10.png',
    'static/mockbillboard/sample11.webp',
]

// Mock data generation function for EXPLORE_PROPERTY_BUTTON
function getLandingPageData() {

    const mockData = {
        data: {
            landingpageExploreButton: Array.from({ length: 6 }, () => ({
                id: faker.string.uuid(),
                foreignBillboardId: null,
                name: faker.location.city(), // Random city name
                displayName: faker.person.firstName(),
                deviceId: null,
                latitude: faker.location.latitude(),
                longitude: faker.location.longitude(),
                category: getRandomElement(['INDOOR', 'OUTDOOR']),
                type: getRandomElement(['DIGITAL', 'STATIC']),
                resolutionWidth: parseFloat(faker.number.float({ min: 720, max: 3840, fractionDigits: 2 }).toFixed(2)),
                resolutionHeight: parseFloat(faker.number.float({ min: 1080, max: 2160, fractionDigits: 2 }).toFixed(2)),
                panelWidth: parseFloat(faker.number.float({ min: 5, max: 20, fractionDigits: 2 }).toFixed(2)),
                panelHeight: parseFloat(faker.number.float({ min: 5, max: 10, fractionDigits: 2 }).toFixed(2)),
                panelSize: parseFloat(faker.number.float({ min: 50, max: 200, fractionDigits: 2 }).toFixed(2)),
                venueType: getRandomElement(['Transit', 'Airports', 'Shopping Area']),

                facingDirection: getRandomElement(['PUBLIC', 'PRIVATE']),
                format: null,
                group: faker.company.name(),
                formattedAddress: null,
                availableDays: faker.number.int({ min: 0, max: 365 }),
                spotsPerHour: faker.number.int({ min: 0, max: 100 }),
                mediaOwnerId: faker.string.uuid(),
                mediaOwnerName: faker.company.name(),
                publisherDomain: null,
                countryId: faker.string.uuid(),
                countryName: faker.location.country(),
                countryIso2: faker.location.countryCode(),
                stateId: faker.string.uuid(),
                stateName: faker.location.state(),
                districtId: faker.string.uuid(),
                districtName: faker.location.city(),
                timezone: faker.location.timeZone(),
                active: faker.datatype.boolean(),
                availableBooking: faker.datatype.boolean(),
                subscription: faker.datatype.boolean(),
                fullResImagePath: `${import.meta.env.VITE_APP_FOLDER_PATH.replace(/\/$/, '')}/${getRandomElement(sampleImages).replace(/^\//, '')}`,
                thumbnailPath: `${import.meta.env.VITE_APP_FOLDER_PATH.replace(/\/$/, '')}/${getRandomElement(sampleImages).replace(/^\//, '')}`,
                googleMapUrl: null,
                programmaticEnabled: faker.datatype.boolean(),
                loopDuration: parseFloat(faker.number.float({ min: 0, max: 60, fractionDigits: 2 }).toFixed(2)),
                spotDuration: null,
                clients: null,
                displayOnTime: null,
                displayOffTime: null,
                totalSpots: faker.number.int({ min: 1000, max: 100000 }),
                totalBookedSpots: faker.number.int({ min: 0, max: 10000 }),
                spotsAvailability: parseFloat(faker.number.float({ min: 0, max: 100 }).toFixed(2)),
                clientsAvailability: parseFloat(faker.number.float({ min: 0, max: 100 }).toFixed(2)),
                nextAvailableDate: faker.date.soon().toISOString().split('T')[0],
                spotAvailabilityPerc: parseFloat(faker.number.float({ min: 0, max: 100 }).toFixed(2)),
                currency: faker.finance.currencyCode(),
                sellingRate: {
                    dsp: null,
                    standard: null,
                    daily: parseFloat(faker.number.float({ min: 10, max: 50 }).toFixed(2)),
                    weekly: parseFloat(faker.number.float({ min: 50, max: 200 }).toFixed(2)),
                    spots: parseFloat(faker.number.float({ min: 0.01, max: 0.1 }).toFixed(2)),
                    monthly: {
                        month3: null,
                        month6: null,
                        month1: parseFloat(faker.number.float({ min: 500, max: 1000 }).toFixed(2)),
                        month12: null
                    },
                    timeOfDay: null,
                    usdStandard: null,
                    usdDaily: null,
                    usdSpots: null,
                    expiryDate: null,
                    discounts: null
                },
                freqModel: null,
                monthlySummary: {
                    id: faker.string.uuid(),
                    childPercentage: parseFloat(faker.number.float({ min: 0, max: 100 }).toFixed(2)),
                    childVisitors: faker.number.int({ min: 0, max: 1000 }),
                    adultPercentage: parseFloat(faker.number.float({ min: 0, max: 100 }).toFixed(2)),
                    adultVisitors: faker.number.int({ min: 0, max: 100000 }),
                    youngAdultPercentage: parseFloat(faker.number.float({ min: 0, max: 100 }).toFixed(2)),
                    youngAdultVisitors: faker.number.int({ min: 0, max: 100000 }),
                    femalePercentage: parseFloat(faker.number.float({ min: 0, max: 100 }).toFixed(2)),
                    femaleVisitors: faker.number.int({ min: 0, max: 100000 }),
                    malePercentage: parseFloat(faker.number.float({ min: 0, max: 100 }).toFixed(2)),
                    maleVisitors: faker.number.int({ min: 0, max: 100000 }),
                    seniorPercentage: parseFloat(faker.number.float({ min: 0, max: 100 }).toFixed(2)),
                    seniorVisitors: faker.number.int({ min: 0, max: 100000 }),
                    totalVisitors: faker.number.int({ min: 1000, max: 2000000 }),
                    uniqueVisitors: faker.number.int({ min: 1000, max: 500000 }),
                    reach: parseFloat(faker.number.float({ min: 0, max: 100 }).toFixed(2)),
                    frequency: parseFloat(faker.number.float({ min: 0, max: 10 }).toFixed(2)),
                    circulation: faker.number.int({ min: 0, max: 1000 })
                },
                createdBy: faker.internet.displayName(),
                createdDate: faker.date.past().toISOString(),
                lastModifiedBy: faker.internet.displayName(),
                lastModifiedDate: faker.date.recent().toISOString(),
                count: 0,
                specification: null,
                price: null,
                trTimeZone: getRandomElement(timeZones),
                trCountryName: faker.location.country(),
                trStateName: faker.location.state(),
                trDistrictName: faker.location.county(),
                tags: null,
                filteringFields: null
            })),
        },
        errors: null, // Optional: add mock errors if needed
    };
    return mockData;
}

function getCampaignListData() {
    // Generate a list of mock campaigns with different inventory types
    const campaigns = Array.from({ length: 12 }, (_, index) => {
        // Determine campaign type: digital (0-3), classic (4-7), packages (8-11)
        const campaignType = index < 4 ? 'digital' : index < 8 ? 'classic' : 'package';
        
        // Set inventory summary based on campaign type
        const inventoriesSummary = campaignType === 'digital' 
            ? { classicInventories: 0, digitalInventories: faker.number.int({ min: 2, max: 5 }), packages: 0 }
            : campaignType === 'classic'
            ? { classicInventories: faker.number.int({ min: 2, max: 5 }), digitalInventories: 0, packages: 0 }
            : { classicInventories: 0, digitalInventories: 0, packages: faker.number.int({ min: 1, max: 3 }) };

        // Determine inventory type for campaign inventories
        const inventoryType = campaignType === 'digital' 
            ? 'DIGITAL_BILLBOARD' 
            : campaignType === 'classic' 
            ? getRandomElement(['STATIC_BILLBOARD', 'CLASSIC_BILLBOARD'])
            : 'PACKAGE';

        const numInventories = campaignType === 'package' 
            ? inventoriesSummary.packages 
            : campaignType === 'digital' 
            ? inventoriesSummary.digitalInventories 
            : inventoriesSummary.classicInventories;

        return {
            id: faker.string.uuid(),
            dealId: faker.string.uuid(),
            name: `${campaignType.charAt(0).toUpperCase() + campaignType.slice(1)} ${faker.commerce.productName()}`,
            bookingSource: getRandomElement(['ONLINE', 'OFFLINE']),
            startDate: {
                date: faker.date.past().toISOString().split('T')[0],
                dateStr: faker.date.past().toISOString().split('T')[0],
                dateFmt: 'yyyy-MM-dd'
            },
            endDate: {
                date: faker.date.future().toISOString().split('T')[0],
                dateStr: faker.date.future().toISOString().split('T')[0],
                dateFmt: 'yyyy-MM-dd'
            },
            dsp: faker.lorem.word(),
            campaignStatus: getRandomElement(['REQUESTED', 'GENERATED', 'APPROVED', 'REJECTED', 'LIVE', 'PAYMENT_PENDING', 'PENDING_PAYMENT_REVIEW']),
            priceSummary: {
                subTotal: parseFloat(faker.commerce.price({ min: 1000, max: 50000 })),
                netTotal: parseFloat(faker.commerce.price({ min: 1000, max: 50000 })),
                currency: {
                    country: faker.location.country(),
                    symbol: faker.finance.currencySymbol(),
                    code: faker.finance.currencyCode()
                },
                tax: {
                    name: faker.finance.transactionType(),
                    value: parseFloat(faker.commerce.price({ min: 100, max: 2000 })),
                    percent: faker.number.int({ min: 5, max: 20 })
                },
                pcrEnable: faker.datatype.boolean()
            },
            inventoriesSummary: inventoriesSummary,
            packages: campaignType === 'package' ? inventoriesSummary.packages : null,
            campaignInventories: Array.from({ length: numInventories }, () => ({
                id: faker.string.uuid(),
                dsp: faker.lorem.word(),
                startDate: faker.date.past().toISOString().split('T')[0],
                endDate: faker.date.future().toISOString().split('T')[0],
                companyId: faker.string.uuid(),
                inventoryName: faker.company.name(),
                inventoryId: faker.string.uuid(),
                inventoryReferenceId: faker.string.uuid(),
                deviceId: null,
                foreignBillboardId: null,
                networkId: null,
                inventoryType: inventoryType,
                inventoryAddress: faker.location.state(),
                inventoryVenueType: faker.lorem.words(3),
                inventoryResolutions: campaignType === 'digital' ? '1920x1080' : null,
                inventoryThumbnailUrl: `${import.meta.env.VITE_APP_FOLDER_PATH.replace(/\/$/, '')}/${getRandomElement(sampleImages).replace(/^\//, '')}`,
                packageDetails: campaignType === 'package' ? {
                    packageName: faker.commerce.productName(),
                    packageId: faker.string.uuid(),
                    totalInventories: faker.number.int({ min: 3, max: 10 })
                } : null,
                inventoryPrice: faker.commerce.price({ min: 100, max: 5000 }),
                inventoryReports: {
                    totalPotentialViews: faker.number.int(),
                    averageFrequency: parseFloat(faker.number.float({ min: 1, max: 10 }).toFixed(2)),
                    cpm: parseFloat(faker.number.float({ min: 0.01, max: 10 }).toFixed(2)),
                    totalReach: faker.number.int()
                },
                inventoryLatitude: faker.location.latitude(),
                inventoryLongitude: faker.location.longitude(),
                inventoryFormat: null,
                nowPayPrice: null,
                discount: null,
                spotDuration: campaignType === 'digital' ? faker.number.int({ min: 10, max: 30 }) : null,
                negotiationSummary: null
            })),
            agency: {
                id: faker.string.uuid(),
                name: faker.company.name()
            },
            company: {
                id: faker.string.uuid(),
                name: faker.company.name()
            },
            user: {
                id: faker.string.uuid(),
                name: faker.internet.displayName()
            },
            summaryReport: {
                potentialViews: faker.number.int(),
                uniqueReach: faker.number.int(),
                cpm: parseFloat(faker.number.float({ min: 0, max: 100 }).toFixed(2)),
                averageFrequency: parseFloat(faker.number.float({ min: 1, max: 10 }).toFixed(2)),
                totalSpots: faker.number.int()
            },
            externalCampaignId: null,
            madCampaignId: null,
            reasonForRejection: null,
            reporting: {
                proofOfPlay: true,
                deliveryReports: true,
            },
            negotiationSummary: null,
            mediaBookingOrdersInvoiceId: null
        };
    });



    return {
        data: {
            mycampaignList: {
                content: campaigns,
                pageable: {
                    sort: {
                        sorted: true,
                        unsorted: false
                    },
                    offset: 0.0,
                    pageSize: 10.0,
                    pageNumber: 0.0,
                    unpaged: false,
                    paged: true
                },
                last: false,
                totalElements: 197.0,
                totalPages: 20.0,
                size: 10.0,
                number: 0.0,
                first: true,
                sort: {
                    sorted: true,
                    unsorted: false
                },
                numberOfElements: 10.0
            }
        }
    };
}

function getContentHubData() {
    const mockData = {
        data: {
            contentHub: Array.from({ length: 10 }, () => ({
                id: faker.string.uuid(),
                fileName: `${faker.system.fileName()}.mp4`,
                mimeType: "video/mp4",
                filePath: `https://test-cdn.movingwalls.com/lmx-ecommerce/lmx_creative_${faker.number.int({ min: 1000000000000, max: 9999999999999 })}_${faker.system.fileName()}.mp4}`,
                userId: faker.string.uuid(),
                companyId: faker.string.uuid(),
                countryId: faker.string.uuid(),
                status: getRandomElement(["PENDING", "APPROVED", "REJECTED"]),
                resolution: `${faker.number.int({ min: 1280, max: 1920 })}x${faker.number.int({ min: 720, max: 1080 })}`,
                userCountry: null,
                thumbnail: `${import.meta.env.VITE_APP_FOLDER_PATH.replace(/\/$/, '')}/${getRandomElement(sampleImages).replace(/^\//, '')}`,
                duration: faker.number.int({ min: 10, max: 30 }),
            })),
        },
        errors: null,
    }
    return mockData
}

function getDeliveryReportData() {
    const mockData = {
        data: {
            deliveryReports: Array.from({ length: 4 }, () => ({
                id: faker.string.uuid(),
                campaignName: faker.commerce.productName(),
                campaignId: faker.string.uuid(),
                campaignStatus: getRandomElement(["APPROVED", "PENDING", "REJECTED"]),
                dealId: `AU-BIG-OSS-${faker.date.future().toISOString().split('T')[0].replace(/-/g, '')}`,
                dsp: faker.lorem.word(),
                agency: {
                    id: faker.string.uuid(),
                    name: faker.company.name()
                },
                startDate: {
                    date: faker.date.future().toISOString().split('T')[0],
                    dateStr: faker.date.future().toISOString().split('T')[0],
                    dateFmt: "yyyy-MM-dd"
                },
                endDate: {
                    date: faker.date.future().toISOString().split('T')[0],
                    dateStr: faker.date.future().toISOString().split('T')[0],
                    dateFmt: "yyyy-MM-dd"
                },
                companyId: faker.string.uuid(),
                inventoryName: faker.location.streetAddress(),
                inventoryId: faker.string.uuid(),
                inventoryReferenceId: `AUS-BIG-D-00000-${faker.number.int({ min: 10000, max: 99999 })}`,
                deviceId: null,
                inventoryType: getRandomElement(["DIGITAL_BILLBOARD", "POSTER", "STATIC"]),
                inventoryAddress: faker.location.state(),
                inventoryVenueType: null,
                inventoryResolutions: null,
                inventoryLocation: null,
                inventoryReports: null,
                inventoryThumbnailUrl: `${import.meta.env.VITE_APP_FOLDER_PATH.replace(/\/$/, '')}/${getRandomElement(sampleImages).replace(/^\//, '')}`,
                inventoryLatitude: faker.location.latitude(),
                inventoryLongitude: faker.location.longitude(),
                inventoryPrice: faker.finance.amount({ min: 10000, max: 50000, dec: 2 }),
                availableBooking: faker.datatype.boolean(),
                nextAvailableDate: faker.date.future().toISOString().split('T')[0],
                spotsAvailability: parseFloat(faker.number.float({ min: 0, max: 100 }).toFixed(2)),
                clientsAvailability: parseFloat(faker.number.float({ min: 0, max: 100 }).toFixed(2)),
                inventoryDetails: {
                    id: faker.string.uuid(),
                    billboardId: null,
                    referenceId: `AUS-BIG-D-00000-${faker.number.int({ min: 10000, max: 99999 })}`,
                    deviceId: null,
                    name: faker.person.firstName(),
                    displayName: faker.person.firstName(),
                    company: faker.company.name(),
                    facingDirection: getRandomElement(["NORTH", "SOUTH", "EAST", "WEST", "PUBLIC"]),
                    category: getRandomElement(["OUTDOOR", "INDOOR"]),
                    group: null,
                    type: getRandomElement(["DIGITAL", "STATIC"]),
                    format: getRandomElement(["BUNTING", "SIGNBOARD"]),
                    venueType: null,
                    latitude: faker.location.latitude(),
                    longitude: faker.location.longitude(),
                    active: faker.datatype.boolean(),
                    country: {
                        id: faker.string.uuid(),
                        countryId: faker.location.countryCode().toLowerCase(),
                        name: faker.location.country(),
                        latitude: faker.location.latitude(),
                        longitude: faker.location.longitude(),
                        population: faker.number.int({ min: 1000000, max: 100000000 }),
                        iso: faker.location.countryCode(),
                        postalformat: "9999",
                        postalname: "Postal code",
                        geopc: faker.number.int({ min: 1, max: 10 }),
                        active: faker.datatype.boolean(),
                        dialingCode: `+${faker.number.int({ min: 1, max: 999 })}`,
                        timezone: faker.location.timeZone(),
                        miDataSensorStatus: null,
                        tax: {
                            label: "GST",
                            percent: parseFloat(faker.number.float({ min: 5, max: 20 }).toFixed(2))
                        }
                    },
                    city: null,
                    companyId: {
                        id: faker.string.uuid(),
                        companyId: faker.company.name().toLowerCase(),
                        name: faker.company.name(),
                        companyType: getRandomElement(["MEDIA_OPERATOR", "ADVERTISER"]),
                        registrationNumber: faker.number.int({ min: 100000000, max: 999999999 }).toString()
                    }
                }
            })),
        },
        errors: null,
    };
    return mockData
}

function getInvoiceData() {
    const campaignInventories = Array.from({ length: 4 }, () => ({
        id: faker.string.uuid(),
        dsp: faker.company.name(),
        startDate: faker.date.future().toISOString().split('T')[0],
        endDate: faker.date.future().toISOString().split('T')[0],
        companyId: faker.string.uuid(),
        inventoryName: faker.location.streetAddress(),
        inventoryId: faker.string.uuid(),
        inventoryReferenceId: `AUS-BIG-D-${faker.number.int(5)}`,
        deviceId: null,
        foreignBillboardId: null,
        networkId: null,
        inventoryType: getRandomElement(['DIGITAL_BILLBOARD', 'digital', 'STATIC_BILLBOARD']),
        inventoryAddress: faker.location.state(),
        inventoryVenueType: null,
        inventoryResolutions: null,
        inventoryThumbnailUrl: `${import.meta.env.VITE_APP_FOLDER_PATH.replace(/\/$/, '')}/${getRandomElement(sampleImages).replace(/^\//, '')}`,
        packageDetails: null,
        inventoryPrice: parseFloat(faker.finance.amount({ min: 20000, max: 40000, dec: 2 })),
        inventoryReports: {
            totalPotentialViews: faker.number.int({ min: 5000, max: 50000 }),
            averageFrequecy: parseFloat(faker.number.float({ min: 1, max: 20 }).toFixed(2)),
            cpm: parseFloat(faker.number.float({ min: 100, max: 300 }).toFixed(2)),
            totalReach: faker.number.int({ min: 100, max: 1000 })
        },
        inventoryLatitude: faker.location.latitude(),
        inventoryLongitude: faker.location.longitude(),
        inventoryFormat: null,
        nowPayPrice: null,
        discount: null,
        spotDuration: null,
        negotiationSummary: null
    }));

    const mockData = {
        data: {
            paymentInvoice: {
                id: faker.string.uuid(),
                dealId: `AU-BIG-OSS-${faker.number.int(15)}`,
                name: faker.commerce.productName(),
                bookingSource: "ONLINE",
                startDate: {
                    date: faker.date.future().toISOString().split('T')[0], // Random future date
                    dateStr: faker.date.future().toISOString().split('T')[0],
                    dateFmt: "yyyy-MM-dd"
                },
                endDate: {
                    date: faker.date.future().toISOString().split('T')[0],
                    dateStr: faker.date.future().toISOString().split('T')[0],
                    dateFmt: "yyyy-MM-dd"
                },
                dsp: faker.company.name(),
                campaignStatus: "LIVE",
                paymentType: getRandomElement(['STRIPE', 'OFFLINE_BNPL', 'OFFLINE_BANK_TRANSFER']),
                priceSummary: {
                    subTotal: faker.finance.amount({ min: 200000, max: 300000, dec: 2 }),
                    netTotal: faker.finance.amount({ min: 220000, max: 350000, dec: 2 }),
                    currency: {
                        country: faker.location.country(),
                        symbol: faker.finance.currencySymbol(),
                        code: faker.finance.currencyCode()
                    },
                    tax: {
                        name: "GST",
                        value: faker.finance.amount({ min: 20000, max: 50000, dec: 2 }),
                        percent: faker.number.int({ min: 5, max: 20 })
                    },
                    pcrEnable: faker.datatype.boolean()
                },
                inventoriesSummary: {
                    classicInventories: 0.0,
                    digitalInventories: faker.number.int({ min: 1, max: 5 }),
                    packages: null
                },
                packages: null,
                campaignInventories: campaignInventories,
                agency: {
                    id: faker.string.uuid(),
                    name: faker.company.name()
                },
                company: {
                    id: faker.string.uuid(),
                    name: faker.company.name()
                },
                user: {
                    id: faker.string.uuid(),
                    name: faker.person.firstName()
                },
                summaryReport: {
                    potentialViews: faker.number.int({ min: 10000, max: 50000 }),
                    uniqueReach: faker.number.int({ min: 100, max: 500 }),
                    cpm: parseFloat(faker.number.float({ min: 400, max: 500 }).toFixed(2)),
                    averageFrequency: parseFloat(faker.number.float({ min: 1, max: 20 }).toFixed(2)),
                    totalSpots: faker.number.int({ min: 10, max: 50 })
                },
                externalCampaignId: null,
                madCampaignId: null,
                reasonForRejection: "",
                reporting: null,
                negotiationSummary: null,
                mediaBookingOrdersInvoiceId: {
                    invoiceId: `INV-AU-BIG-OSS-${faker.number.int(12)}`
                }
            }
        }
    };
    return mockData
}

function getCartItemData() {
    const campaigns = Array.from({ length: 5 }, () => ({
        billboardPotentialViews: faker.number.int({ min: 1000, max: 2000000 }),
        billboardId: faker.string.uuid(),
        billboardName: faker.company.name(),
        billboardType: getRandomElement(['digital', 'classic']),
        billboardCountry: faker.location.country(),
        billboardDeviceId: faker.string.uuid(),
        billboardReferenceId: "AUS-OUT-D-" + faker.number.int({ min: 10000, max: 99999 }).toString().padStart(5, '0'),
        billboardLatitude: parseFloat(faker.number.float({ min: -90, max: 90, fractionDigits: 4 }).toFixed(2)),
        billboardVenueType: getRandomElement(['Outdoor', 'Indoor']),
        billboardFrequency: parseFloat(faker.number.float({ min: 1, max: 10, fractionDigits: 4 }).toFixed(2)),
        billboardLongitude: parseFloat(faker.number.float({ min: -180, max: 180, fractionDigits: 4 }).toFixed(2)),
        billboardUniqueReach: faker.number.int({ min: 1000, max: 1000000 }),
        billboardResolutionWidth: faker.number.int({ min: 720, max: 1920 }).toString(), // Random resolution width between 720 and 1920, converted to string
        billboardResolutionHeight: faker.number.int({ min: 1080, max: 2160 }).toString(),
        billboardtotalPrice: faker.commerce.price({ min: 100, max: 1000, dec: 2 }),
        billboardThumbnailUrl: `${import.meta.env.VITE_APP_FOLDER_PATH.replace(/\/$/, '')}/${getRandomElement(sampleImages).replace(/^\//, '')}`,
        billboardPeriodSubTotalPrice: faker.commerce.price({ min: 100, max: 500 }).toString(),
        mediaOwnerId: faker.string.uuid(),
        mediaOwnerName: faker.company.name()
    }));
    const mockData = {
        data: {
            cartPageItem: Array.from({ length: 1 }, () => {
                const overAlltotalPrice = faker.commerce.price({ min: 600, max: 1100, dec: 2 });
                const overAlltotalTax = faker.commerce.price({ min: 50, max: 100, dec: 2 });

                return {
                    userId: faker.string.uuid(),
                    agencyId: faker.string.uuid(),
                    agencyName: faker.company.name(),
                    companyId: faker.string.uuid(),
                    companyName: faker.company.name(),
                    countryId: faker.string.uuid(),
                    countryName: faker.location.country(),
                    campaignName: faker.lorem.words(3),
                    startDate: faker.date.soon({ days: 10 }).toISOString().split('T')[0],
                    endDate: faker.date.future({ years: 0.1 }).toISOString().split('T')[0],
                    inventoriesSummary: {
                        classicInventories: faker.number.int({ min: 1, max: 5 }),
                        digitalInventories: faker.number.int({ min: 1, max: 5 }),
                        packages: null
                    },
                    overAlltotalPrice,
                    overAlltotalTax,
                    overAlltotalNet: (parseFloat(overAlltotalPrice) + parseFloat(overAlltotalTax)).toFixed(2),
                    overAlltotalUniqueReach: faker.number.int({ min: 10000, max: 500000 }),
                    overAlltotalPotentialViews: faker.number.int({ min: 1000000, max: 5000000 }),
                    overAlltotalAverageFrequency: faker.number.float({ min: 5, max: 20, fractionDigits: 2 }),
                    campaignInventories: campaigns
                };
            }),
        },
        errors: null,
    };
    return mockData;

}

function getPropertyListData() {
    const mockData = {
        data: {
            landingpageExploreProperties: Array.from({ length: 12 }, () => ({
                id: faker.string.uuid(),
                name: faker.location.city().toLowerCase(),
                displayName: faker.person.firstName(),
                referenceId: `AUS-OUT-D-00000-${faker.number.int({ min: 10000, max: 99999 })}`,
                latitude: faker.location.latitude(),
                longitude: faker.location.longitude(),
                category: getRandomElement(["INDOOR", "OUTDOOR"]),
                type: getRandomElement(["DIGITAL", "STATIC"]),
                panelWidth: parseFloat(faker.number.float({ min: 5, max: 15 }).toFixed(2)),
                panelHeight: parseFloat(faker.number.float({ min: 5, max: 10 }).toFixed(2)),
                resolutionWidth: faker.number.int({ min: 720, max: 2160 }),
                resolutionHeight: faker.number.int({ min: 1280, max: 3840 }),
                panelSize: parseFloat(faker.number.float({ min: 50, max: 100 }).toFixed(2)),
                formattedAddress: faker.location.streetAddress(),
                facingDirection: getRandomElement(["NORTH", "SOUTH", "EAST", "WEST", "PUBLIC"]),
                group: faker.commerce.department(),
                venueType: getRandomElement(["Transit,Airports,Shopping Area", "Retail,Commercial"]),
                currentPrice: faker.finance.amount({ min: 20, max: 10000, dec: 2 }),
                mediaOwnerId: faker.string.uuid(),
                specification: null,
                mediaOwnerName: faker.company.name(),
                countryId: faker.string.uuid(),
                countryName: faker.location.country(),
                stateId: faker.string.uuid(),
                stateName: faker.location.state(),
                districtId: faker.string.uuid(),
                districtName: faker.location.city(),
                active: faker.datatype.boolean(),
                availableBooking: faker.datatype.boolean(),
                subscription: faker.datatype.boolean(),
                fullResImagePath: `${import.meta.env.VITE_APP_FOLDER_PATH.replace(/\/$/, '')}/${getRandomElement(sampleImages).replace(/^\//, '')}`,
                thumbnailPath: `${import.meta.env.VITE_APP_FOLDER_PATH.replace(/\/$/, '')}/${getRandomElement(sampleImages).replace(/^\//, '')}`,
                googleMapUrl: faker.internet.url(),
                timezone: faker.location.timeZone(),
                totalSpots: faker.number.int({ min: 0, max: 100 }),
                totalBookedSpots: faker.number.int({ min: 0, max: 100 }),
                spotsAvailability: parseFloat(faker.number.float({ min: 0, max: 1 }).toFixed(2)),
                spotAvailabilityPerc: parseFloat(faker.number.float({ min: 0, max: 1 }).toFixed(2)),
                clientsAvailability: parseFloat(faker.number.float({ min: 0, max: 1 }).toFixed(2)),
                nextAvailableDate: faker.date.future().toISOString().split('T')[0],
                currency: faker.finance.currencyCode(),
                createdBy: faker.internet.displayName(),
                createdDate: faker.date.past().toISOString(),
                lastModifiedBy: faker.internet.displayName(),
                lastModifiedDate: faker.date.recent().toISOString(),
                count: faker.number.int({ min: 0, max: 100 }),
                trTimeZone: faker.location.timeZone(),
                trCountryName: faker.location.country(),
                trStateName: faker.location.state(),
                trDistrictName: faker.location.city(),
                sellingRate: {
                    dsp: null,
                    daily: faker.finance.amount({ min: 10, max: 100 }),
                    weekly: faker.finance.amount({ min: 100, max: 1000 }),
                    spots: faker.finance.amount({ min: 0.01, max: 0.1 }),
                    monthly: {
                        month1: faker.finance.amount({ min: 500, max: 1500 }),
                        month3: null,
                        month6: null,
                        month12: null
                    },
                    usdStandard: null,
                    usdDaily: null,
                    usdSpots: null,
                    expiryDate: null,
                    discounts: null
                },
                monthlySummary: {
                    id: faker.string.uuid(),
                    childPercentage: parseFloat(faker.number.float({ min: 0, max: 1 }).toFixed(2)),
                    totalVisitors: faker.number.int({ min: 10000, max: 2000000 })
                }
            })),
        },
        errors: null,
    };
    return mockData
}


function getExplorePropertyListData() {
    const mockData = {
        data: {
            landingpageExplorePropertiesNotoken: Array.from({ length: 12 }, () => ({
                id: faker.string.uuid(),
                name: faker.location.city().toLowerCase(),
                displayName: faker.person.firstName(),
                referenceId: `AUS-OUT-D-00000-${faker.number.int({ min: 10000, max: 99999 })}`,
                latitude: faker.location.latitude(),
                longitude: faker.location.longitude(),
                category: getRandomElement(["INDOOR", "OUTDOOR"]),
                type: getRandomElement(["DIGITAL", "STATIC", "CLASSIC"]),
                panelWidth: parseFloat(faker.number.float({ min: 5, max: 15 }).toFixed(2)),
                panelHeight: parseFloat(faker.number.float({ min: 5, max: 10 }).toFixed(2)),
                resolutionWidth: faker.number.int({ min: 720, max: 2160 }),
                resolutionHeight: faker.number.int({ min: 1280, max: 3840 }),
                panelSize: parseFloat(faker.number.float({ min: 50, max: 100 }).toFixed(2)),
                formattedAddress: faker.location.streetAddress(),
                facingDirection: getRandomElement(["NORTH", "SOUTH", "EAST", "WEST", "PUBLIC"]),
                group: faker.commerce.department(),
                venueType: getRandomElement(["Transit,Airports,Shopping Area", "Retail,Commercial"]),
                mediaOwnerId: faker.string.uuid(),
                specification: {
                    playerSoftware: faker.commerce.productName(),
                    contentApproval: faker.datatype.boolean(),
                    screens: faker.number.int({ min: 1, max: 10 }).toString(),
                    panel: faker.commerce.productMaterial(),
                },
                playerSoftwareModule: {
                    description: faker.lorem.sentence(),
                },
                mediaOwnerName: faker.company.name(),
                countryId: faker.string.uuid(),
                countryName: faker.location.country(),
                stateId: faker.string.uuid(),
                stateName: faker.location.state(),
                districtId: faker.string.uuid(),
                districtName: faker.location.city(),
                active: faker.datatype.boolean(),
                availableBooking: faker.datatype.boolean(),
                subscription: faker.datatype.boolean(),
                fullResImagePath: `${import.meta.env.VITE_APP_FOLDER_PATH.replace(/\/$/, '')}/${getRandomElement(sampleImages).replace(/^\//, '')}`,
                thumbnailPath: `${import.meta.env.VITE_APP_FOLDER_PATH.replace(/\/$/, '')}/${getRandomElement(sampleImages).replace(/^\//, '')}`,
                googleMapUrl: faker.internet.url(),
                timezone: faker.location.timeZone(),
                totalSpots: faker.number.int({ min: 0, max: 100 }),
                totalBookedSpots: faker.number.int({ min: 0, max: 100 }),
                spotsAvailability: parseFloat(faker.number.float({ min: 0, max: 1 }).toFixed(2)),
                spotAvailabilityPerc: parseFloat(faker.number.float({ min: 0, max: 1 }).toFixed(2)),
                clientsAvailability: parseFloat(faker.number.float({ min: 0, max: 1 }).toFixed(2)),
                nextAvailableDate: faker.date.future().toISOString().split('T')[0],
                currency: faker.finance.currencyCode(),
                createdBy: faker.internet.displayName(),
                createdDate: faker.date.past().toISOString(),
                lastModifiedBy: faker.internet.displayName(),
                lastModifiedDate: faker.date.recent().toISOString(),
                count: faker.number.int({ min: 0, max: 100 }),
                trTimeZone: faker.location.timeZone(),
                trCountryName: faker.location.country(),
                trStateName: faker.location.state(),
                trDistrictName: faker.location.city(),
                billboardSize: faker.commerce.productMaterial(),
                exclusion: faker.lorem.words(3),
                sellAsNetwork: faker.datatype.boolean() ? "YES" : "NO",
                videoSupport: [getRandomElement(["MP4", "AVI", "MOV"])],
                imageSupport: [getRandomElement(["JPEG", "PNG", "TIFF"])],
                featureSupport: [getRandomElement(["LIVE STREAM", "DYNAMIC CONTENT"])],
                audioSupport: getRandomElement(["MP3", "WAV"]),
                audioFormats: [getRandomElement(["AAC", "OGG"])],
                formats: getRandomElement(["16:9", "4:3"]),
                panelFormat: getRandomElement(["LED", "LCD"]),
                panels: [faker.commerce.productMaterial()],
                ledPitch: faker.number.float({ min: 2, max: 10 }).toFixed(2),
                sellingRate: {
                    dsp: null,
                    daily: faker.finance.amount({ min: 10, max: 100 }),
                    weekly: faker.finance.amount({ min: 100, max: 1000 }),
                    spots: faker.finance.amount({ min: 0.01, max: 0.1 }),
                    monthly: {
                        month1: faker.finance.amount({ min: 500, max: 1500 }),
                        month3: null,
                        month6: null,
                        month12: null,
                    },
                },
                // ✅ Audience Data Fix
                monthlySummary: {
                    id: faker.string.uuid(),
                    reach: faker.number.int({ min: 1000, max: 500000 }),
                    uniqueVisitors: faker.number.int({ min: 1000, max: 500000 }),
                    frequency: parseFloat(faker.number.float({ min: 0, max: 10 }).toFixed(2)),
                    totalVisitors: faker.number.int({ min: 10000, max: 2000000 }),
                    seniorPercentage: parseFloat(faker.number.float({ min: 0, max: 100 }).toFixed(2)),
                    adultPercentage: parseFloat(faker.number.float({ min: 0, max: 100 }).toFixed(2)),
                    youngAdultPercentage: parseFloat(faker.number.float({ min: 0, max: 100 }).toFixed(2)),
                    malePercentage: parseFloat(faker.number.float({ min: 0, max: 100 }).toFixed(2)),
                    femalePercentage: parseFloat(faker.number.float({ min: 0, max: 100 }).toFixed(2)),
                },

                loopDuration: faker.number.int({ min: 10, max: 300 }),
                displayOnTime: "06:00",
                displayOffTime: "22:00",
                price: {
                    spotDuration: faker.number.int({ min: 5, max: 60 }),
                    modeOfOperation: getRandomElement(["AUTOMATIC", "MANUAL"]),
                    loopDuration: faker.number.int({ min: 10, max: 300 }).toString(),
                    screenOnTime: "06:00",
                    programmaticEnabled: faker.datatype.boolean() ? "Yes" : "No",
                    contentFrequencyPerHour: faker.number.int({ min: 1, max: 10 }),
                    clients: faker.number.int({ min: 1, max: 20 }),
                    maximumSpotDurationPerDay: faker.number.int({ min: 100, max: 500 }),
                    minimumSpotDurationPerDay: faker.number.int({ min: 10, max: 50 }),
                },
                availableDays: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
            })),
        },
        errors: null,
    };
    return mockData;
}


function getPropertyDetailsData() {
    const mockData = {
        data: {
            propertyDetails: {
                id: faker.string.uuid(),
                referenceId: `AUS-OUT-D-${faker.number.int({ min: 10000, max: 99999 })}-${faker.number.int({ min: 10000, max: 99999 })}`,
                deviceId: faker.string.uuid(),
                name: faker.location.city(),
                displayName: `${faker.location.city()}${faker.number.int({ min: 1, max: 100 })}`,
                company: faker.company.name(),
                facingDirection: getRandomElement(["PUBLIC", "PRIVATE"]),
                cardinalPoint: getRandomElement(["N", "S", "E", "W"]),
                category: getRandomElement(["INDOOR", "OUTDOOR"]),
                subCategory: getRandomElement(["Airport", "Mall", "Transit"]),
                type: getRandomElement(["DIGITAL", "STATIC"]),
                format: getRandomElement(["LED TV", "Digital Billboard"]),
                latitude: faker.location.latitude(),
                longitude: faker.location.longitude(),
                venueType: getRandomElement(["Transit", "Airports", "Shopping Area"]),
                formattedAddress: faker.location.streetAddress(),
                availableBooking: faker.datatype.boolean(),
                active: faker.datatype.boolean(),
                totalVisitors: faker.number.int({ min: 1000, max: 500000 }),
                mediaOwnerName: faker.company.name(),
                nextAvailableDate: faker.date.future().toISOString().substring(0, 10),

                specification: {
                    leadTime: faker.number.int({ min: 1, max: 30 }),
                    panel: faker.number.int(),
                    screens: faker.number.int(),
                    resolution1Width: faker.number.int({ min: 720, max: 3840 }).toString(),
                    resolution1Height: faker.number.int({ min: 480, max: 2160 }).toString(),
                    panel1Width: faker.number.int({ min: 1, max: 20 }),
                    panel1Height: faker.number.int({ min: 1, max: 20 }),
                    panel1Size: faker.number.float({ min: 10, max: 100, fractionDigits: 2 }),
                    videoSupport: faker.datatype.boolean(),
                    imageSupport: faker.datatype.boolean(),
                    audioSupport: faker.datatype.boolean(),
                    audioFormats: ["mp3", "aac"],
                    contentApproval: faker.datatype.boolean(),
                    featureSupport: ["Dynamic Content", "Programmatic"],
                    availableHours: "06:00-22:00",
                    heightFromFloor: faker.number.float({ min: 2, max: 10, fractionDigits: 1 }),
                    billboardSize: `${faker.number.float({ min: 5, max: 20, fractionDigits: 1 })} x ${faker.number.float({ min: 5, max: 20, fractionDigits: 1 })}`,
                    playerSoftwareModule: {
                        id: faker.string.uuid(),
                        name: faker.company.name(),
                        shortName: faker.commerce.productName(),
                        description: faker.lorem.sentence(),
                        apiUrl: faker.internet.url(),
                        accessToken: faker.string.uuid(),
                        active: faker.datatype.boolean(),
                        integratedWithLmx: faker.datatype.boolean(),
                        allowedPushToContentTypes: ["HTML", "ZIP", "VAST", "URL"],
                        creativeConfiguration: null,
                        resolutionMode: getRandomElement(["FullHD", "4K"])
                    },
                    exclusionCategory: {
                        id: faker.string.uuid(),
                        iabCode: "IAB1",
                        value: "Category A",
                        trValue: "Translated A",
                        children: []
                    }
                },

                price: {
                    screenOnTime: "06:00",
                    screenOffTime: "22:00",
                    displayOnTime: "06:00",
                    displayOffTime: "22:00",
                    spotDuration: 10,
                    contentFrequencyPerHour: 60,
                    clients: faker.number.int({ min: 1, max: 10 }),
                    localCurrencies: [
                        {
                            id: faker.string.uuid(),
                            currencyId: faker.finance.currencyCode(),
                            iso: faker.finance.currencyCode(),
                            country: faker.location.country(),
                            currency: faker.finance.currencyName(),
                            code: faker.finance.currencyCode(),
                            symbol: "$",
                            numcode: "840",
                            decimals: 2,
                            locale: "en-US"
                        }
                    ],
                    availableDays: "All Days",
                    minimumSpotDurationPerDay: 600,
                    maximumSpotDurationPerDay: 1200,
                    modeOfOperation: "Loop Based",
                    loopDuration: 120,
                    programmaticEnabled: faker.datatype.boolean(),
                    exposeToBuyer: faker.datatype.boolean(),
                    dealType: "Private",
                    openAuctionType: "First Price",
                    openAuctionCurrency: "USD",
                    openAuctionSpotDuration: 15
                },

                thumbnailPath: `${import.meta.env.VITE_APP_FOLDER_PATH.replace(/\/$/, '')}/${getRandomElement(sampleImages).replace(/^\//, '')}`,
                timezone: "Australia/Brisbane",
                trTimeZone: "AEST",
                trFormat: "Digital",
                createdDate: faker.date.past().toISOString(),
                lastModifiedBy: faker.person.fullName(),
                lastModifiedDate: faker.date.recent().toISOString(),
                totalBillboardCount: faker.number.int({ min: 1, max: 50 }),
                summaryMonth: faker.date.month(),

                companyId: {
                    id: faker.string.uuid(),
                    companyId: faker.string.uuid(),
                    name: faker.company.name(),
                    companyType: "Media",
                    registrationNumber: faker.string.numeric(8),
                    registrationAddress: {
                        street: faker.location.street(),
                        city: faker.location.city(),
                        state: faker.location.state(),
                        country: faker.location.country(),
                        postCode: faker.location.zipCode(),
                        building: faker.location.streetAddress(),
                        trCountryName: faker.location.country(),
                        trStateName: faker.location.state(),
                        trDistrictName: faker.location.city(),
                        concatenatedAddress: faker.location.streetAddress()
                    }
                },

                country: {
                    id: faker.string.uuid(),
                    name: faker.location.country(),
                    nameJa: "国名",
                    latitude: faker.location.latitude(),
                    longitude: faker.location.longitude(),
                    zoom: 10,
                    swLat: faker.location.latitude(),
                    swLng: faker.location.longitude(),
                    seLat: faker.location.latitude(),
                    seLng: faker.location.longitude(),
                    neLat: faker.location.latitude(),
                    neLng: faker.location.longitude(),
                    nwLat: faker.location.latitude(),
                    nwLng: faker.location.longitude(),
                    population: faker.number.int({ min: 10000, max: 1000000 }),
                    iso: faker.location.countryCode(),
                    locale: "en-US",
                    countryId: faker.string.uuid(),
                    active: faker.datatype.boolean(),
                    trCountryName: faker.location.country(),
                    tax: { label: "VAT", percent: 10 }
                },

                state: {
                    id: faker.string.uuid(),
                    name: faker.location.state(),
                    nameJa: "州名",
                    stateId: faker.string.uuid(),
                    type: "State",
                    latitude: faker.location.latitude(),
                    longitude: faker.location.longitude(),
                    zoom: 8,
                    swLat: faker.location.latitude(),
                    swLng: faker.location.longitude(),
                    seLat: faker.location.latitude(),
                    seLng: faker.location.longitude(),
                    neLat: faker.location.latitude(),
                    neLng: faker.location.longitude(),
                    nwLat: faker.location.latitude(),
                    nwLng: faker.location.longitude(),
                    population: faker.number.int({ min: 1000, max: 100000 }),
                    iso: faker.location.countryCode(),
                    locale: "en-US",
                    trStateName: faker.location.state(),
                    country: {
                        id: faker.string.uuid(),
                        countryId: faker.string.uuid(),
                        name: faker.location.country(),
                        trCountryName: faker.location.country()
                    }
                },

                district: {
                    id: faker.string.uuid(),
                    name: faker.location.city(),
                    nameJa: "地区",
                    districtId: faker.string.uuid(),
                    type: "District",
                    latitude: faker.location.latitude(),
                    longitude: faker.location.longitude(),
                    zoom: 6,
                    swLat: faker.location.latitude(),
                    swLng: faker.location.longitude(),
                    seLat: faker.location.latitude(),
                    seLng: faker.location.longitude(),
                    neLat: faker.location.latitude(),
                    neLng: faker.location.longitude(),
                    nwLat: faker.location.latitude(),
                    nwLng: faker.location.longitude(),
                    population: faker.number.int({ min: 100, max: 100000 }),
                    locale: "en-US",
                    trDistrictName: faker.location.city(),
                    state: {
                        id: faker.string.uuid(),
                        stateId: faker.string.uuid(),
                        name: faker.location.state(),
                        trStateName: faker.location.state()
                    }
                },

                sellingRate: {
                    dsp: faker.commerce.price({ min: 5, max: 50, dec: 2 }),
                    daily: faker.commerce.price({ min: 10, max: 50, dec: 2 }),
                    weekly: faker.commerce.price({ min: 100, max: 200, dec: 2 }),
                    monthly: {
                        month1: faker.commerce.price({ min: 600, max: 700, dec: 2 }),
                        month3: faker.commerce.price({ min: 1700, max: 1900, dec: 2 }),
                        month6: faker.commerce.price({ min: 3000, max: 3500, dec: 2 }),
                        month12: faker.commerce.price({ min: 6000, max: 7000, dec: 2 })
                    }
                },

                monthlySummary: {
                    id: faker.string.uuid(),
                    childPercentage: faker.number.float({ min: 0, max: 100, fractionDigits: 2 }),
                    childVisitors: faker.number.int({ min: 0, max: 1000 }),
                    adultPercentage: faker.number.float({ min: 0, max: 100, fractionDigits: 2 }),
                    adultVisitors: faker.number.int({ min: 0, max: 100000 }),
                    youngAdultPercentage: faker.number.float({ min: 0, max: 100, fractionDigits: 2 }),
                    youngAdultVisitors: faker.number.int({ min: 0, max: 100000 }),
                    femalePercentage: faker.number.float({ min: 0, max: 100, fractionDigits: 2 }),
                    femaleVisitors: faker.number.int({ min: 0, max: 100000 }),
                    malePercentage: faker.number.float({ min: 0, max: 100, fractionDigits: 2 }),
                    maleVisitors: faker.number.int({ min: 0, max: 100000 }),
                    seniorPercentage: faker.number.float({ min: 0, max: 100, fractionDigits: 2 }),
                    seniorVisitors: faker.number.int({ min: 0, max: 100000 }),
                    totalVisitors: faker.number.int({ min: 1000, max: 2000000 }),
                    uniqueVisitors: faker.number.int({ min: 1000, max: 500000 }),
                    reach: faker.number.float({ min: 0, max: 100, fractionDigits: 2 }),
                    frequency: faker.number.float({ min: 0, max: 10, fractionDigits: 2 }),
                    circulation: faker.number.int({ min: 0, max: 1000 })
                }
            }
        }
    }
    return mockData
}


function getBubbleData() {
    const mockData = {
        data: {
            bubbleChartData: [
                {
                    segments: [
                        {
                            name: "INTERESTS",
                            firstLevel: [
                                {
                                    name: "Young Families",
                                    value: faker.number.float({ min: 1000, max: 50000 }),
                                    secondLevel: []
                                }
                            ]
                        },
                        {
                            name: "ACTIONS",
                            firstLevel: [
                                {
                                    name: "Commuters",
                                    value: faker.number.float({ min: 50000, max: 100000 }),
                                    secondLevel: []
                                }
                            ]
                        },
                        {
                            name: "INCOME GROUP",
                            firstLevel: [
                                {
                                    name: "Affluent People",
                                    value: faker.number.float({ min: 1000, max: 10000 }),
                                    secondLevel: []
                                }
                            ]
                        },
                        {
                            name: "OCCUPATION",
                            firstLevel: [
                                {
                                    name: "Biz Owners",
                                    value: faker.number.float({ min: 5000, max: 15000 }),
                                    secondLevel: []
                                },
                                {
                                    name: "White Collars",
                                    value: faker.number.float({ min: 1000, max: 5000 }),
                                    secondLevel: []
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    };
    return mockData;
}



function getCartDetails() {
    const mockData = {
        data: {
            cartpageItem: Array.from({ length: 5 }, () => ({
                id: faker.string.uuid(),
                userId: faker.string.uuid(),
                campaignName: faker.commerce.productName(),
                startDate: faker.date.soon({ days: 10 }).toISOString().split('T')[0], // random start date within 10 days
                endDate: faker.date.future({ years: 0.1 }).toISOString().split('T')[0],
                cartItemName: faker.commerce.productName(),
                cartItemId: faker.string.uuid(),
                cartItemReferenceId: faker.string.uuid(),
                cartItemDeviceId: null,
                cartItemType: getRandomElement(['DIGITAL', 'STATIC']),
                cartItemCountry: faker.location.country(),
                cartItemVenueType: getRandomElement(['DIGITAL', 'STATIC']),
                cartItemResolutions: null,
                cartItemThumbnailUrl: `${import.meta.env.VITE_APP_FOLDER_PATH.replace(/\/$/, '')}/${getRandomElement(sampleImages).replace(/^\//, '')}`,
                cartItemLatitude: faker.location.latitude(),
                cartItemLongitude: faker.location.longitude(),
                availableBooking: faker.datatype.boolean(),
                nextAvailableDate: faker.date.soon().toISOString().split('T')[0],
                spotsAvailability: parseFloat(faker.number.float({ min: 0, max: 100 }).toFixed(2)),
                clientsAvailability: parseFloat(faker.number.float({ min: 0, max: 100 }).toFixed(2)),
                mediaOwnerId: faker.string.uuid(),
                mediaOwnerName: faker.company.name()
            })),
        },
        errors: null,
    };
    return mockData
}

function getProofOfPlayData() {
    const campaignInventories = Array.from({ length: 5 }, () => ({
        id: faker.string.uuid(),
        dsp: "ECOMMERCE",
        startDate: faker.date.future().toISOString().split('T')[0], // Generate a future start date
        endDate: faker.date.future({ years: 1 }).toISOString().split('T')[0], // Generate a future end date
        companyId: faker.string.uuid(),
        inventoryName: `${faker.location.city()} ${faker.commerce.productName()}`, // Generate a city and product name
        inventoryId: faker.string.uuid(),
        inventoryReferenceId: `AUS-BIG-D-${faker.number.int({ min: 10000, max: 99999 })}-${faker.number.int({ min: 10000, max: 99999 })}`, // Generate a reference ID
        inventoryType: "DIGITAL_BILLBOARD", // Hardcoded as "DIGITAL_BILLBOARD"
        inventoryAddress: faker.location.state(), // Generate a state as the address
        inventoryVenueType: null, // Set as null
        inventoryThumbnailUrl: `${import.meta.env.VITE_APP_FOLDER_PATH.replace(/\/$/, '')}/${getRandomElement(sampleImages).replace(/^\//, '')}`,
        inventoryPrice: faker.commerce.price({ min: 10000, max: 50000, dec: 2 }), // Generate a price between 10,000 and 50,000 with 2 decimal places
        inventoryReports: {
            totalPotentialViews: faker.number.int({ min: 1000, max: 10000 }), // Generate a number for total potential views
            averageFrequency: null, // Set as null
            cpm: parseFloat(faker.commerce.price({ min: 100, max: 200, dec: 6 })), // Generate a price for CPM between 100 and 200 with 6 decimal places
            totalReach: faker.number.int({ min: 100, max: 5000 }) // Generate a number for total reach
        },
        inventoryLatitude: faker.location.latitude(), // Generate a latitude
        inventoryLongitude: faker.location.longitude() // Generate a longitude
    }))
    const mockData = {
        data: {
            proofOfPlay: {
                id: faker.string.uuid(),
                dealId: `AU-BIG-OSS-${faker.date.recent().toISOString().split('T')[0].replace(/-/g, '').slice(2)}${faker.number.int({ min: 0, max: 23 }).toString().padStart(2, '0')}${faker.number.int({ min: 0, max: 59 }).toString().padStart(2, '0')}${faker.number.int({ min: 0, max: 59 }).toString().padStart(2, '0')}`,
                name: faker.commerce.productName(),
                bookingSource: "ONLINE",
                startDate: {
                    date: faker.date.future({ years: 0.1 }).toISOString().split('T')[0],
                    dateStr: faker.date.future({ years: 0.1 }).toISOString().split('T')[0],
                    dateFmt: "yyyy-MM-dd"
                },
                endDate: {
                    date: faker.date.future({ years: 0.5 }).toISOString().split('T')[0],
                    dateStr: faker.date.future({ years: 0.5 }).toISOString().split('T')[0],
                    dateFmt: "yyyy-MM-dd"
                },
                dsp: "ECOMMERCE",
                campaignStatus: getRandomElement(["LIVE", "PAUSED", "COMPLETED"]),
                packages: null,
                campaignInventories: campaignInventories
            }
        }
    }
    return mockData
}

function getProofOfPlayAssets() {
    const mockData = {
        data: {
            proofOfPlayAssets: Array.from({ length: 2 }, () => ({

                id: faker.string.uuid(),
                creativeRefId: faker.string.uuid(),
                masterCreativeId: faker.string.uuid(),
                fileName: `${faker.number.int(7)}-uhd_3840_2160_25fps.mp4`,
                mimeType: "video/mp4", // This is likely to remain constant
                fileSize: faker.number.int({ min: 1000000, max: 50000000 }), // e.g., between 1MB and 50MB
                duration: faker.number.float({ min: 5, max: 30, fractionDigits: 2 }), // Duration in seconds, e.g., between 5 and 30 seconds
                filePath: `${import.meta.env.VITE_APP_FOLDER_PATH.replace(/\/$/, '')}/${getRandomElement(sampleImages).replace(/^\//, '')}`,
                thumbnail: `${import.meta.env.VITE_APP_FOLDER_PATH.replace(/\/$/, '')}/${getRandomElement(sampleImages).replace(/^\//, '')}`,
                thumbnailAvailable: faker.datatype.boolean(),
                userId: faker.string.uuid(),
                companyId: faker.string.uuid(),
                countryId: faker.string.uuid(),
                source: getRandomElement(["LMX_COMMERCE", "LMX_DIRECT", "LMX_AGENCY"]),
                status: getRandomElement(["APPROVED", "PENDING", "REJECTED"]),
                metadata: {
                    type: getRandomElement(["LMX_POC", "LMX_CAMPAIGN"]),
                    campaignId: faker.string.uuid(),
                    billboardId: faker.string.uuid(),
                    mediaOwnerId: faker.string.uuid(),
                    date: faker.date.recent().toISOString(),
                    month: getRandomElement(["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"]),
                    startDate: faker.date.soon().toISOString(),
                    endDate: faker.date.future().toISOString()
                },
                resolution: "3840x2160", // This is likely to remain constant
                comments: faker.lorem.sentence(),
                maxAssignedCreativeId: faker.string.uuid(),
                proofOfPlayStatus: getRandomElement([null, "PLAYED", "NOT_PLAYED"]),
                rejectMessage: getRandomElement([null, faker.lorem.sentence()]),
                title: faker.commerce.productName(),
                description: faker.lorem.sentences(),
                creativeName: faker.company.name(),
                creativeAdType: getRandomElement(["VIDEO", "IMAGE", "GIF"]),
                callToActionUrl: faker.internet.url(),
                callToActionText: faker.lorem.words(3),
                createdBy: faker.internet.displayName(),
                createdDate: faker.date.past().toISOString(),
                lastModifiedBy: faker.internet.displayName(),
                lastModifiedDate: faker.date.recent().toISOString()

            }))
        }
    }
    return mockData
}

function getAssignCreativeItem() {
    const mockData = {
        data: {
            assignCreativesItem: Array.from({ length: 3 }, () => ({
                id: faker.string.uuid(),
                campaignName: faker.commerce.productName().toLowerCase().replace(/\s/g, ''),
                campaignId: faker.string.uuid(),
                campaignStatus: getRandomElement(['APPROVED', 'PENDING', 'REJECTED']),
                dealId: `AU-BIG-OSS-${faker.date.future().toISOString().slice(0, 10).replace(/-/g, '')}`,
                dsp: getRandomElement(['ECOMMERCE', 'AD_NETWORK']),
                agency: {
                    id: faker.string.uuid(),
                    name: faker.company.name(),
                },
                startDate: {
                    date: faker.date.soon().toISOString().split('T')[0],
                    dateStr: faker.date.soon().toISOString().split('T')[0],
                    dateFmt: "yyyy-MM-dd",
                },
                endDate: {
                    date: faker.date.future().toISOString().split('T')[0],
                    dateStr: faker.date.future().toISOString().split('T')[0],
                    dateFmt: "yyyy-MM-dd",
                },
                companyId: faker.string.uuid(),
                inventoryName: faker.commerce.productName(),
                inventoryId: faker.string.uuid(),
                inventoryReferenceId: `AUS-BIG-D-${faker.number.int({ min: 10000, max: 99999 })}`,
                deviceId: null,
                inventoryType: getRandomElement(['DIGITAL_BILLBOARD', 'STATIC_BILLBOARD']),
                inventoryAddress: faker.location.state(),
                inventoryVenueType: faker.lorem.words(10).split(' ').join(','),
                inventoryResolutions: null,
                inventoryLocation: null,
                inventoryReports: {
                    totalPotentialViews: faker.number.int({ min: 1000, max: 20000 }),
                    averageFrequency: faker.number.float({ min: 1, max: 10, fractionDigits: 2 }),
                    cpm: faker.number.float({ min: 50, max: 200, fractionDigits: 2 }),
                    totalReach: faker.number.int({ min: 100, max: 5000 }),
                },
                inventoryDetails: {
                    resolution1Width: faker.number.int({ min: 1280, max: 3840 }),
                    resolution1Height: faker.number.int({ min: 720, max: 2160 }),
                    panel1Width: faker.number.float({ min: 10, max: 50 }),
                    panel1Height: faker.number.float({ min: 10, max: 50 }),
                    panel1Size: faker.number.float({ min: 50, max: 200 }),
                },
                inventoryThumbnailUrl: `${import.meta.env.VITE_APP_FOLDER_PATH.replace(/\/$/, '')}/${getRandomElement(sampleImages).replace(/^\//, '')}`,
                inventoryLatitude: faker.location.latitude(),
                inventoryLongitude: faker.location.longitude(),
                inventoryPrice: faker.number.float({ min: 10000, max: 50000, fractionDigits: 2 })
            })),
        },
        errors: null, // Optional: add mock errors if needed
    };
    return mockData;
}

function getAssignedContent() {
    const mockData = {
        data: {
            assignedContent: Array.from({ length: 4 }, () => ({
                id: faker.string.uuid(),
                masterCreativeId: faker.string.uuid(),
                status: getRandomElement(['APPROVED']),
                resolution: `${faker.number.int({ min: 1920, max: 3840 })}x${faker.number.int({ min: 1080, max: 2160 })}`,
                fileName: `${faker.number.int()}-${faker.system.fileExt()}`,
                thumbnail: `${import.meta.env.VITE_APP_FOLDER_PATH.replace(/\/$/, '')}/${getRandomElement(sampleImages).replace(/^\//, '')}`,
            })),
        },
        errors: null, // Optional: add mock errors if needed
    };
    return mockData;
}

function getEcommerceAssetsData() {
    const mockData = {
        data: {
            ecommerceAssets: Array.from({ length: 10 }, () => ({
                id: faker.string.uuid(),
                creativeRefId: faker.string.uuid(),
                masterCreativeId: faker.string.uuid(),
                fileName: `${faker.system.commonFileName()}.mp4`,
                mimeType: "video/mp4",
                fileSize: faker.number.int({ min: 1000000, max: 10000000 }), // file size in bytes
                duration: parseFloat(faker.number.float({ min: 5, max: 60, fractionDigits: 2 }).toFixed(2)), // random duration in seconds
                filePath: faker.internet.url(),
                thumbnail: `${import.meta.env.VITE_APP_FOLDER_PATH.replace(/\/$/, '')}/${getRandomElement(sampleImages).replace(/^\//, '')}`,
                thumbnailAvailable: faker.datatype.boolean(),
                userId: faker.string.uuid(),
                companyId: faker.string.uuid(),
                countryId: faker.string.uuid(),
                source: getRandomElement(['LMX_COMMERCE', 'ONLINE']),
                status: getRandomElement(['PENDING', 'APPROVED', 'REJECTED']),
                metadata: {
                    type: 'LMX_CREATIVE',
                    dealId: faker.string.uuid(),
                    campaignId: faker.string.uuid(),
                    billboardId: faker.string.uuid(),
                    mediaOwnerId: faker.string.uuid(),
                    agencyId: faker.string.uuid(),
                    comments: faker.lorem.sentence(),
                    folder: faker.system.filePath(),
                    approvedBy: faker.person.firstName(),
                    rejectedBy: faker.person.firstName(),
                    maxStatus: getRandomElement(['APPROVED', 'REJECTED']),
                    campaign: faker.datatype.boolean(),
                    buyerCreativeId: faker.string.uuid(),
                    brandId: faker.string.uuid(),
                    productId: faker.string.uuid(),
                    tagIds: [faker.string.uuid(), faker.string.uuid()]
                },
                resolution: `${faker.number.int({ min: 1280, max: 3840 })}x${faker.number.int({ min: 720, max: 2160 })}`,
                comments: faker.lorem.sentence(),
                maxAssignedCreativeId: faker.string.uuid(),
                proofOfPlayStatus: getRandomElement(['PENDING', 'COMPLETED']),
                rejectMessage: faker.lorem.sentence(),
                title: faker.lorem.words(),
                description: faker.lorem.sentences(),
                creativeName: faker.commerce.productName(),
                creativeAdType: getRandomElement(['BANNER', 'VIDEO', 'CAROUSEL']),
                callToActionUrl: faker.internet.url(),
                callToActionText: faker.lorem.words(),
                createdBy: faker.internet.displayName(),
                createdDate: faker.date.past().toISOString(),
                lastModifiedBy: faker.internet.displayName(),
                lastModifiedDate: faker.date.recent().toISOString()
            })),
        },
        errors: null, // Optional: add mock errors if needed
    };
    return mockData;
}

function getEditCartItemData() {
    const campaigns = Array.from({ length: 5 }, () => ({
        billboardPotentialViews: faker.number.int({ min: 1000, max: 2000000 }),
        billboardId: faker.string.uuid(),
        billboardName: faker.company.name(),
        billboardType: getRandomElement(['digital', 'classic']),
        billboardCountry: faker.location.country(),
        billboardDeviceId: faker.string.uuid(),
        billboardReferenceId: "AUS-OUT-D-" + faker.number.int({ min: 10000, max: 99999 }).toString().padStart(5, '0'),
        billboardLatitude: faker.number.float({ min: -90, max: 90, fractionDigits: 4 }),
        billboardVenueType: getRandomElement(['Outdoor', 'Indoor']),
        billboardFrequency: faker.number.float({ min: 1, max: 10, fractionDigits: 4 }),
        billboardLongitude: faker.number.float({ min: -180, max: 180, fractionDigits: 4 }),
        billboardUniqueReach: faker.number.int({ min: 1000, max: 1000000 }),
        billboardResolutionWidth: faker.number.int({ min: 720, max: 1920 }).toString(), // Random resolution width between 720 and 1920, converted to string
        billboardResolutionHeight: faker.number.int({ min: 1080, max: 2160 }).toString(),
        billboardtotalPrice: faker.commerce.price({ min: 100, max: 1000, dec: 2 }),
        billboardThumbnailUrl: `${import.meta.env.VITE_APP_FOLDER_PATH.replace(/\/$/, '')}/${getRandomElement(sampleImages).replace(/^\//, '')}`,
        billboardFullResImageUrl: `${import.meta.env.VITE_APP_FOLDER_PATH.replace(/\/$/, '')}/${getRandomElement(sampleImages).replace(/^\//, '')}`,
        billboardPeriodSubTotalPrice: faker.commerce.price({ min: 100, max: 500 }).toString(),
    }));
    const mockData = {
        data: {
            editPageItem: Array.from({ length: 1 }, () => ({
                userId: faker.string.uuid(), // random UUID for user ID
                agencyId: faker.string.uuid(), // random UUID for agency ID
                agencyName: faker.company.name(), // random agency name
                companyId: faker.string.uuid(), // random UUID for company ID
                companyName: faker.company.name(), // random company name
                countryId: faker.string.uuid(), // random UUID for country ID
                countryName: faker.location.country(), // random country name
                campaignName: faker.lorem.words(3), // random campaign name with 3 words
                startDate: faker.date.soon({ days: 10 }).toISOString().split('T')[0], // random start date within 10 days
                endDate: faker.date.future({ years: 1 }).toISOString().split('T')[0], // random end date soon after start date
                overAlltotalNet: faker.commerce.price({ min: 500, max: 1000, dec: 2 }), // random price with 2 decimal places for net total
                overAlltotalTax: faker.commerce.price({ min: 50, max: 100, dec: 2 }), // random tax price with 2 decimal places
                overAlltotalPrice: faker.commerce.price({ min: 600, max: 1100, dec: 2 }), // random total price with 2 decimal places
                overAlltotalUniqueReach: faker.number.int({ min: 10000, max: 500000 }), // random unique reach
                overAlltotalPotentialViews: faker.number.int({ min: 1000000, max: 5000000 }), // random potential views
                overAlltotalAverageFrequency: faker.number.float({ min: 5, max: 20, fractionDigits: 2 }),
                campaignInventories: campaigns
            })),
        },
        errors: null, // Optional: add mock errors if needed
    };
    return mockData;
}

function getNegotiateCampaignData() {
    const campaigns = Array.from({ length: 5 }, () => ({
        id: faker.string.uuid(), // Randomly generate unique ID
        dsp: faker.company.name(), // Generate random company name
        startDate: faker.date.future().toISOString().split('T')[0], // Generate random future start date
        endDate: faker.date.future().toISOString().split('T')[0], // Generate random future end date
        inventoryName: faker.location.city(), // Generate random city name as inventory name
        inventoryId: faker.string.uuid(), // Generate random inventory ID
        inventoryThumbnailUrl: `${import.meta.env.VITE_APP_FOLDER_PATH.replace(/\/$/, '')}/${getRandomElement(sampleImages).replace(/^\//, '')}`,
        inventoryType: getRandomElement(['digital', 'classic']),
        inventoryReports: {
            totalPotentialViews: null, // Keep null or generate a random number if needed
            averageFrequency: null, // Keep null or generate a random value if needed
            cpm: faker.finance.amount({ min: 0.01, max: 0.05, dec: 8 }), // Generate a random CPM between 0.01 and 0.05 with 8 decimal places
            totalReach: null // Keep null or generate a random number if needed
        },
        discount: null, // Keep null or generate a random discount if needed
        negotiationSummary: {
            buyerPreferredPrice: {
                totalPrice: parseFloat(faker.finance.amount({ min: 100, max: 1000, dec: 2 })), // Generate a random total price
                savingsPrice: faker.finance.amount({ min: 0, max: 500, dec: 2 }), // Generate random savings price
                savingsPerc: faker.finance.amount({ min: 0, max: 100, dec: 2 }), // Generate random savings percentage
                nowPayPrice: parseFloat(faker.finance.amount({ min: 100, max: 1000, dec: 2 })), // Generate random current pay price
                dailyPrice: null, // Keep null or generate random daily price if needed
                subTotal: null // Keep null or generate a random subtotal if needed
            },
            mediaOwnerPreferredPrice: {
                totalPrice: parseFloat(faker.finance.amount({ min: 100, max: 1000, dec: 2 })), // Generate a random total price
                savingsPrice: faker.finance.amount({ min: 0, max: 500, dec: 2 }), // Generate random savings price
                savingsPerc: faker.finance.amount({ min: 0, max: 100, dec: 2 }), // Generate random savings percentage
                nowPayPrice: parseFloat(faker.finance.amount({ min: 100, max: 1000, dec: 2 })), // Generate random current pay price
                dailyPrice: null, // Keep null or generate random daily price if needed
                subTotal: null // Keep null or generate a random subtotal if needed
            },
            contentManagementFeePerc: faker.finance.amount({ min: 0, max: 10, dec: 1 }).toString(), // Generate a random fee percentage
            platformFeePerc: faker.finance.amount({ min: 10, max: 20, dec: 1 }).toString(), // Generate a random platform fee percentage
            taxPerc: faker.finance.amount({ min: 0, max: 30, dec: 1 }).toString(), // Generate a random tax percentage
            discountPerc: faker.finance.amount({ min: 0, max: 20, dec: 1 }).toString(), // Generate a random discount percentage
            customFees: [], // Keep empty or generate random custom fees
            summaryReport: {
                potentialViews: faker.number.int({ min: 100000, max: 2000000 }), // Generate random potential views
                uniqueReach: faker.number.int({ min: 50000, max: 300000 }), // Generate random unique reach
                cpm: null, // Keep null or generate random CPM
                totalSpots: null // Keep null or generate random total spots if needed
            },
            status: "PENDING", // Keep static or randomize if needed
            accountType: "EXTERNAL", // Keep static or randomize if needed
            requestFrom: null // Keep null or generate random value if needed
        }
    }));

    const mockData = {
        data: {
            negotiateCampaign: {
                id: faker.string.uuid(), // Randomly generate unique ID
                dealId: `AU-BIG-OSS-${faker.number.int({ min: 100000000000, max: 999999999999 })}`, // Generate random deal ID
                name: faker.lorem.word(), // Random campaign name
                bookingSource: getRandomElement(["ONLINE", "OFFLINE"]), // Randomly pick between online or offline
                startDate: {
                    date: faker.date.future().toISOString().split('T')[0], // Generate random future start date
                    dateStr: faker.date.future().toISOString().split('T')[0], // Same as start date in string format
                    dateFmt: "yyyy-MM-dd" // Static format
                },
                endDate: {
                    date: faker.date.future().toISOString().split('T')[0], // Generate random future end date
                    dateStr: faker.date.future().toISOString().split('T')[0], // Same as end date in string format
                    dateFmt: "yyyy-MM-dd" // Static format
                },
                dsp: faker.company.name(), // Generate random company name
                campaignStatus: getRandomElement(["NEGOTIATION_REQUESTED", "NEGOTIATION_ACCEPTED", "CLOSED"]), // Random status
                priceSummary: {
                    subTotal: faker.finance.amount({ min: 100, max: 1000, dec: 3 }), // Random subtotal
                    netTotal: faker.finance.amount({ min: 100, max: 1000, dec: 3 }), // Random net total
                    currency: {
                        country: faker.location.country(), // Random country name
                        symbol: faker.finance.currencySymbol(), // Random currency symbol
                        code: faker.finance.currencyCode() // Random currency code
                    },
                    tax: {
                        name: getRandomElement(["GST", "VAT"]), // Random tax name
                        value: faker.finance.amount({ min: 10, max: 100, dec: 2 }), // Random tax value
                        percent: faker.finance.amount({ min: 0, max: 20, dec: 1 }) // Random tax percentage
                    },
                    pcrEnable: faker.datatype.boolean() // Random boolean for PCR enable
                },
                inventoriesSummary: {
                    classicInventories: faker.finance.amount({ min: 0, max: 10, dec: 1 }), // Random number for classic inventories
                    digitalInventories: faker.finance.amount({ min: 0, max: 10, dec: 1 }), // Random number for digital inventories
                    packages: null // Keep null
                },
                packages: null, // Keep null
                campaignInventories: campaigns,
                agency: {
                    id: faker.string.uuid(), // Randomly generate unique ID for agency
                    name: faker.company.name() // Generate random agency name
                },
                company: {
                    id: faker.string.uuid(), // Randomly generate unique ID for company
                    name: faker.company.name() // Generate random company name
                },
                user: {
                    id: faker.string.uuid(), // Randomly generate unique user ID
                    name: faker.internet.displayName() // Random username
                },
                summaryReport: {
                    potentialViews: faker.number.int({ min: 100000, max: 2000000 }), // Random potential views
                    uniqueReach: faker.number.int({ min: 50000, max: 300000 }), // Random unique reach
                    cpm: faker.finance.amount({ min: 0.01, max: 0.05, dec: 2 }), // Random CPM value
                    averageFrequency: parseFloat(faker.finance.amount({ min: 1, max: 10, dec: 8 })), // Random frequency with 8 decimal points
                    totalSpots: faker.number.int({ min: 1, max: 50 }) // Random total spots
                },
                externalCampaignId: null, // Keep null
                madCampaignId: null, // Keep null
                reasonForRejection: null, // Keep null
                reporting: {
                    proofOfPlay: faker.datatype.boolean(), // Random boolean for proof of play
                    deliveryReports: faker.datatype.boolean() // Random boolean for delivery reports
                },
                negotiationSummary: {
                    buyerPreferredPrice: {
                        totalPrice: faker.finance.amount({ min: 100, max: 1000, dec: 2 }), // Random total price
                        savingsPrice: faker.finance.amount({ min: 0, max: 500, dec: 2 }), // Random savings price
                        savingsPerc: faker.finance.amount({ min: 0, max: 100, dec: 2 }), // Random savings percentage
                        nowPayPrice: faker.finance.amount({ min: 100, max: 1000, dec: 2 }), // Random now pay price
                        dailyPrice: faker.finance.amount({ min: 10, max: 100, dec: 2 }), // Random daily price
                        subTotal: null // Keep null
                    },
                    mediaOwnerPreferredPrice: {
                        totalPrice: parseFloat(faker.finance.amount({ min: 100, max: 2000, dec: 2 })), // Random total price
                        savingsPrice: faker.finance.amount({ min: 0, max: 500, dec: 2 }), // Random savings price
                        savingsPerc: faker.finance.amount({ min: 0, max: 100, dec: 2 }), // Random savings percentage
                        nowPayPrice: faker.finance.amount({ min: 100, max: 2000, dec: 2 }), // Random now pay price
                        dailyPrice: faker.finance.amount({ min: 10, max: 100, dec: 2 }), // Random daily price
                        subTotal: null // Keep null
                    },
                    contentManagementFeePerc: faker.finance.amount({ min: 0, max: 10, dec: 1 }).toString(), // Random fee percentage
                    platformFeePerc: faker.finance.amount({ min: 10, max: 20, dec: 1 }).toString(), // Random platform fee percentage
                    taxPerc: faker.finance.amount({ min: 0, max: 30, dec: 1 }).toString(), // Random tax percentage
                    discountPerc: faker.finance.amount({ min: 0, max: 20, dec: 1 }).toString(), // Random discount percentage
                    customFees: [], // Keep empty or generate random custom fees if needed
                    summaryReport: {
                        potentialViews: faker.number.int({ min: 100000, max: 2000000 }), // Random potential views
                        uniqueReach: faker.number.int({ min: 50000, max: 300000 }), // Random unique reach
                        cpm: null, // Keep null or generate random CPM if needed
                        totalSpots: faker.number.int({ min: 1, max: 50 }) // Random total spots
                    },
                    status: getRandomElement(["PENDING", "APPROVED", "REJECTED"]), // Random negotiation status
                    accountType: null, // Keep null or generate random value if needed
                    requestFrom: null // Keep null or generate random value if needed
                }
            }
        }
    };

    return mockData;
}

function getCountryCodeData() {
    const mockData = {
        data: {
            getCountryCodeNoToken: {
                countryId: faker.string.uuid(),
                countryName: faker.location.country(),
                tax: {
                    label: faker.commerce.productAdjective().toUpperCase(), // e.g., "GST Tax", "VAT Tax"
                    percent: faker.number.float({ min: 0, max: 20, fractionDigits: 1 }) // Random tax percentage between 0 and 20 with 1 decimal place
                }
            }
        }
    }
    return mockData
}

function getCurrencyCodeData() {
    const mockData = {
        data: {
            currencyCodeDetails: {
                country: faker.location.country(),
                currencyCode: faker.finance.currencyCode(),
            }
        }
    }
    return mockData
}


function authenticate() {
    const mockData = {
        data: {
            authenticate: {
                authData: {
                    expiresIn: faker.number.int({ min: 1000, max: 86400 }), // Simulate a time in seconds
                    scope: `${faker.lorem.word()} ${faker.lorem.word()}`, // Randomly generate a scope string
                    tokenType: 'bearer', // You can keep this static if it's always 'bearer'
                    accessToken: faker.string.uuid() // Generate a random token string
                }
            }
        }
    };
    return mockData
}

function userData() {
    const mockData = {
        data: {
            userAccount: [
                {
                    id: faker.string.uuid(), // Randomly generate a unique ID
                    login: faker.internet.displayName(), // Generate a random username
                    password: null, // Keep null or generate if needed
                    firstName: faker.person.firstName(), // Generate a random first name
                    lastName: faker.person.lastName(), // Generate a random last name
                    phone: faker.phone.number(), // Generate a random phone number
                    email: faker.internet.email(), // Generate a random email
                    activated: true, // Keep static if always true
                    langKey: "en", // Generate a random language key
                    authorities: ["ROLE_PUBLIC_USER"], // Keep static or modify as per roles
                    accountType: "EXTERNAL", // Static, or use faker for random types
                    companyName: faker.company.name(), // Generate a random company name
                    companyId: faker.string.uuid(), // Generate a random company ID
                    companyType: "MEDIA_BUYERS", // Keep static or generate dynamically
                    country: {
                        id: faker.string.uuid(), // Generate a random country ID
                        countryId: faker.string.uuid(), // Country code
                        name: faker.location.country(), // Generate a random country name
                        nameJa: faker.location.country(), // Use same country name or modify
                        latitude: faker.location.latitude(), // Generate random latitude
                        longitude: faker.location.longitude(), // Generate random longitude
                        tax: {
                            label: "GST", // Tax label, can remain static
                            percent: faker.finance.amount({ min: 0, max: 20, dec: 1 })
                        }
                    },
                    lastModifiedBy: faker.internet.displayName(),
                    lastModifiedDate: faker.date.recent().toISOString(),
                    ecommerceDomainName: `${faker.internet.domainWord()}.lmx.ai`, // Generate random domain
                    userCompanyName: faker.company.name(), // Generate random company name
                    userCompanyId: faker.string.uuid(), // Generate random company ID
                    userCompanyAddress: faker.location.country(), // Generate random company address
                    userCompanyPhoneNumber: faker.phone.number(), // Generate random phone number
                    platform: "ECOMMERCE", // Static platform value
                    userCountry: faker.location.country() // Generate random user country
                }
            ]
        }
    };
    return mockData;
}

function GetThreeBillboard() {
    const mockData = {
        data: {
            topThreeBillboard: Array.from({ length: 10 }, () => ({
                id: faker.string.uuid(), // Randomly generate a unique ID
                stateId: faker.string.uuid(),
                stateName: faker.location.state(),
                displayName: faker.person.firstName(),
                priceRates: faker.commerce.price({ min: 1000, max: 50000 }),
                thumbnailPath: `${import.meta.env.VITE_APP_FOLDER_PATH.replace(/\/$/, '')}/${getRandomElement(sampleImages).replace(/^\//, '')}`,
                billboardType: getRandomElement(['digital', 'classic']),
                billboardObjectId: faker.string.uuid(), // Added field
                weeklyPrice: faker.commerce.price({ min: 100, max: 1000 }),
                totalVisitors: faker.number.int({ min: 1_000_000, max: 3_000_000 }),
                totalViews: faker.number.int({ min: 1_000_000, max: 3_000_000 }),
                currentPrice: faker.commerce.price({ min: 500, max: 5000 }), // Added field
                perDayPrice: faker.commerce.price({ min: 50, max: 500 }),    // Added field
                perSpotPrice: faker.commerce.price({ min: 10, max: 100 }),   // Added field
                currencyCode: faker.finance.currencyCode(), // Added field
            }))
        }
    };

    return mockData;
}



function GetGalleryImageInDetails() {
    const mockData = {
        data: {
            galleryImageAssets: [
                {
                    id: faker.string.uuid(),
                    fileName: faker.system.fileName(),
                    mimeType: getRandomElement(['image/jpeg', 'image/png', 'image/gif', 'video/mp4']),
                    fileSize: faker.number.float({ min: 1000, max: 10000000 }), // File size in bytes
                    duration: faker.number.float({ min: 10, max: 300 }), // Duration in seconds (for videos)
                    filePath: faker.system.filePath(),
                    thumbnail: `${import.meta.env.VITE_APP_FOLDER_PATH.replace(/\/$/, '')}/${getRandomElement(sampleImages).replace(/^\//, '')}`,
                    thumbnailAvailable: faker.datatype.boolean(),
                    userId: faker.string.uuid(),
                    companyId: faker.string.uuid(),
                    countryId: faker.string.uuid(),
                    source: getRandomElement(['User', 'Admin', 'System']),
                    status: getRandomElement(['active', 'inactive', 'pending']),
                    metaData: {
                        type: getRandomElement(['image', 'video']),
                        billboardId: faker.string.uuid(),
                        mediaOwnerId: faker.string.uuid(),
                        tagged: faker.datatype.boolean(),
                        latitude: faker.location.latitude(),
                        longitude: faker.location.longitude(),
                        comments: faker.lorem.sentence(),
                        tags: Array.from({ length: 3 }, () => faker.lorem.word()),
                        primary: faker.datatype.boolean(),
                        secondary: faker.datatype.boolean(),
                        source: getRandomElement(['Internal', 'External']),
                        uploadedBy: faker.string.uuid(),
                        falcon: faker.datatype.boolean(),
                    },
                    resolution: getRandomElement(['1920x1080', '1280x720', '3840x2160']),
                    comments: faker.lorem.sentence(),
                    maxAssignedCreativeId: faker.string.uuid(),
                    proofOfPlayStatus: getRandomElement(['played', 'not_played', 'error']),
                    rejectMessage: faker.lorem.sentence(),
                    title: faker.lorem.sentence(),
                    description: faker.lorem.paragraph(),
                    creativeName: faker.company.name(),
                    creativeAdType: getRandomElement(['video', 'banner', 'carousel']),
                    callToActionUrl: faker.internet.url(),
                    callToActionText: faker.lorem.words(),
                    createdBy: faker.string.uuid(),
                    createdDate: faker.date.past(),
                    lastModifiedBy: faker.string.uuid(),
                    lastModifiedDate: faker.date.recent(),
                }
            ]
        }
    };

    return mockData;
}


function getVenueTypeListData() {
    // Explicitly define the return type of the generateChild function as an array of objects
    const generateChild = (level: number = 1): { id: string; name: string; value: string; child: any[] }[] => {
        if (level > 3) return []; // stop after 3 levels

        return Array.from({ length: 3 }, () => ({
            id: faker.string.uuid(),
            name: faker.lorem.word(),
            value: faker.lorem.word(),
            child: generateChild(level + 1), // recursive for deeper levels
        }));
    };

    const mockData = {
        data: {
            venueTypes: Array.from({ length: 5 }, () => ({
                id: faker.string.uuid(),
                name: faker.lorem.word(),
                value: faker.lorem.word(),
                child: generateChild(1), // generate 1st level child nodes
            })),
        },
    };

    return mockData;
}

function getStateList() {
    const mockData = {
        data: {
            stateList: Array.from({ length: 10 }, () => ({
                stateId: faker.string.uuid(),
                name: faker.location.state(),
            }))
        }
    }
    return mockData;
}

function getCompanyPaymentOptionsMock() {
    const mockData = {
        data: {
            companyPaymentOptions: [
                {
                    id: faker.string.uuid(),
                    paymentType: 'OFFLINE_BANK_TRANSFER',
                    active: true,
                    paymentMetadata: {
                        bankName: 'DBS Bank',
                        accountName: 'MovingWalls Pte Ltd',
                        accountNumber: '123456789',
                        additionalDetails: {
                            swiftCode: 'DBSSSGSG',
                            bankBranchCode: '001',
                            bankCountry: 'Singapore',
                            customFieldLabel: 'Reference',
                            customFieldValue: 'Please include campaign ID'
                        }
                    }
                },
                {
                    id: faker.string.uuid(),
                    paymentType: 'STRIPE',
                    active: true,
                    paymentMetadata: {
                        stripeAccessKey: `pk_test_${faker.string.alphanumeric(24)}`,
                        stripeSecretKey: `sk_test_${faker.string.alphanumeric(24)}`
                    }
                },
                {
                    id: faker.string.uuid(),
                    paymentType: 'OFFLINE_BNPL',
                    active: true,
                    paymentMetadata: {
                        providerName: 'FlexiPay Singapore',
                        providerContactPerson: faker.person.fullName(),
                        providerContactNumber: faker.phone.number(),
                        providerEmail: faker.internet.email(),
                        termsUrl: 'https://example.com/bnpl-terms'
                    }
                }
            ]
        }
    };
    return mockData;
}

function getPaymentTransactionDetailsMock() {
    const mockData = {
        data: {
            paymentTransactionDetails: {
                paymentId: faker.string.uuid(),
                paymentReferenceId: `PAY-${faker.number.int({ min: 100000, max: 999999 })}`,
                paymentType: getRandomElement(['STRIPE', 'BANK_TRANSFER', 'BNPL']),
                paymentStatus: getRandomElement(['PENDING', 'COMPLETED', 'APPROVED', 'REJECTED']),
                paymentProviderMedata: {
                    accountName: faker.company.name(),
                    bankName: 'DBS Bank',
                    accountNumber: faker.finance.accountNumber()
                },
                campaign: {
                    id: faker.string.uuid(),
                    dealId: `AU-BIG-OSS-${faker.date.recent().toISOString().split('T')[0].replace(/-/g, '')}`,
                    name: faker.commerce.productName(),
                    bookingSource: getRandomElement(['ONLINE', 'OFFLINE']),
                    startDate: {
                        date: faker.date.future().toISOString().split('T')[0],
                        dateStr: faker.date.future().toISOString().split('T')[0],
                        dateFmt: 'yyyy-MM-dd'
                    },
                    endDate: {
                        date: faker.date.future().toISOString().split('T')[0],
                        dateStr: faker.date.future().toISOString().split('T')[0],
                        dateFmt: 'yyyy-MM-dd'
                    },
                    dsp: 'ECOMMERCE',
                    campaignStatus: getRandomElement(['PAYMENT_PENDING', 'APPROVED', 'LIVE']),
                    priceSummary: {
                        grossTotal: parseFloat(faker.commerce.price({ min: 1200, max: 15000 })),
                        subTotal: parseFloat(faker.commerce.price({ min: 1000, max: 10000 })),
                        netTotal: parseFloat(faker.commerce.price({ min: 1100, max: 12000 })),
                        currency: {
                            country: faker.location.country(),
                            symbol: faker.finance.currencySymbol(),
                            code: faker.finance.currencyCode()
                        },
                        tax: {
                            name: 'GST',
                            value: parseFloat(faker.commerce.price({ min: 100, max: 1000 })),
                            percent: 10
                        },
                        pcrEnable: faker.datatype.boolean(),
                        couponName: getRandomElement(['SAVE20', 'WELCOME10', null, null]),
                        discountPercent: parseFloat(faker.number.float({ min: 0, max: 20 }).toFixed(2)),
                        discountedPrice: parseFloat(faker.commerce.price({ min: 0, max: 500 }))
                    },
                    inventoriesSummary: {
                        classicInventories: faker.number.int({ min: 0, max: 5 }),
                        digitalInventories: faker.number.int({ min: 1, max: 10 }),
                        packages: null
                    },
                    campaignInventories: Array.from({ length: 3 }, () => ({
                        id: faker.string.uuid(),
                        dsp: 'ECOMMERCE',
                        startDate: faker.date.future().toISOString().split('T')[0],
                        endDate: faker.date.future().toISOString().split('T')[0],
                        companyId: faker.string.uuid(),
                        inventoryName: faker.location.streetAddress(),
                        inventoryId: faker.string.uuid(),
                        inventoryReferenceId: `AUS-BIG-D-${faker.number.int({ min: 10000, max: 99999 })}`,
                        inventoryType: 'DIGITAL_BILLBOARD',
                        inventoryVenueType: getRandomElement(['Transit', 'Retail', 'Airport']),
                        inventoryThumbnailUrl: `${import.meta.env.VITE_APP_FOLDER_PATH.replace(/\/$/, '')}/${getRandomElement(sampleImages).replace(/^\//, '')}`,
                        inventoryPrice: parseFloat(faker.commerce.price({ min: 500, max: 5000 })),
                        inventoryReports: {
                            totalPotentialViews: faker.number.int({ min: 10000, max: 500000 }),
                            averageFrequency: parseFloat(faker.number.float({ min: 1, max: 10 }).toFixed(2)),
                            cpm: parseFloat(faker.number.float({ min: 1, max: 50 }).toFixed(2)),
                            totalReach: faker.number.int({ min: 5000, max: 100000 })
                        },
                        inventoryLatitude: faker.location.latitude(),
                        inventoryLongitude: faker.location.longitude(),
                        isSpotBased: faker.datatype.boolean()
                    })),
                    agency: {
                        id: faker.string.uuid(),
                        name: faker.company.name()
                    },
                    company: {
                        id: faker.string.uuid(),
                        name: faker.company.name()
                    },
                    user: {
                        id: faker.string.uuid(),
                        name: faker.person.fullName()
                    },
                    summaryReport: {
                        potentialViews: faker.number.int({ min: 100000, max: 1000000 }),
                        uniqueReach: faker.number.int({ min: 50000, max: 500000 }),
                        cpm: parseFloat(faker.number.float({ min: 1, max: 20 }).toFixed(2)),
                        averageFrequency: parseFloat(faker.number.float({ min: 1, max: 10 }).toFixed(2)),
                        totalSpots: faker.number.int({ min: 100, max: 10000 })
                    },
                    reporting: {
                        proofOfPlay: true,
                        deliveryReports: true
                    },
                    mediaOwners: [faker.company.name(), faker.company.name()],
                    buyerDetails: {
                        name: faker.person.fullName(),
                        companyName: faker.company.name(),
                        email: faker.internet.email(),
                        mobile: faker.phone.number(),
                        address: faker.location.streetAddress()
                    },
                    createdDate: faker.date.past().toISOString(),
                    lastModifiedDate: faker.date.recent().toISOString()
                },
                assets: Array.from({ length: 2 }, () => ({
                    id: faker.string.uuid(),
                    fileName: `payment_receipt_${faker.number.int({ min: 1000, max: 9999 })}.pdf`,
                    duration: null,
                    filePath: `${import.meta.env.VITE_APP_FOLDER_PATH.replace(/\/$/, '')}/static/mockbillboard/sample1.jpg`,
                    metadata: null,
                    resolution: null,
                    createdDate: faker.date.recent().toISOString(),
                    lastModifiedDate: faker.date.recent().toISOString()
                }))
            }
        }
    };
    return mockData;
}

function getOfflinePaymentInvoiceMock() {
    const mockData = {
        data: {
            offlinePaymentInvoice: {
                invoiceId: faker.string.uuid(),
                referenceInvoiceNumber: `INV-${faker.number.int({ min: 100000, max: 999999 })}`,
                paymentType: getRandomElement(['BANK_TRANSFER', 'BNPL']),
                paymentTransaction: {
                    id: faker.string.uuid(),
                    publisherId: faker.string.uuid(),
                    campaignId: faker.string.uuid(),
                    campaignName: faker.commerce.productName(),
                    dealId: `AU-BIG-OSS-${faker.date.recent().toISOString().split('T')[0].replace(/-/g, '')}`,
                    amount: parseFloat(faker.commerce.price({ min: 1000, max: 50000 })),
                    currency: faker.finance.currencyCode(),
                    customerEmail: faker.internet.email(),
                    paymentProvider: 'OFFLINE',
                    paymentStatus: getRandomElement(['PENDING', 'APPROVED', 'REJECTED']),
                    status: getRandomElement(['PENDING', 'COMPLETED']),
                    failureReason: null,
                    failureCode: null,
                    failureMessage: null,
                    transactionId: faker.string.alphanumeric(16),
                    receiptUrl: faker.internet.url(),
                    webhookProcessed: false,
                    createdDate: faker.date.past().toISOString(),
                    lastModifiedDate: faker.date.recent().toISOString(),
                    providerMetadata: {
                        accountName: faker.company.name(),
                        accountNumber: faker.finance.accountNumber(),
                        bankName: 'DBS Bank'
                    }
                },
                campaign: {
                    id: faker.string.uuid(),
                    dealId: `AU-BIG-OSS-${faker.date.recent().toISOString().split('T')[0].replace(/-/g, '')}`,
                    name: faker.commerce.productName(),
                    bookingSource: 'ONLINE',
                    dsp: 'ECOMMERCE',
                    campaignStatus: 'PAYMENT_PENDING',
                    createdDate: faker.date.past().toISOString(),
                    lastModifiedDate: faker.date.recent().toISOString(),
                    mediaOwners: [faker.company.name()],
                    startDate: {
                        date: faker.date.future().toISOString().split('T')[0],
                        dateStr: faker.date.future().toISOString().split('T')[0],
                        dateFmt: 'yyyy-MM-dd'
                    },
                    endDate: {
                        date: faker.date.future().toISOString().split('T')[0],
                        dateStr: faker.date.future().toISOString().split('T')[0],
                        dateFmt: 'yyyy-MM-dd'
                    },
                    priceSummary: {
                        subTotal: parseFloat(faker.commerce.price({ min: 1000, max: 10000 })),
                        netTotal: parseFloat(faker.commerce.price({ min: 1100, max: 12000 })),
                        pcrEnable: false,
                        currency: {
                            country: faker.location.country(),
                            symbol: faker.finance.currencySymbol(),
                            code: faker.finance.currencyCode()
                        },
                        tax: {
                            name: 'GST',
                            value: parseFloat(faker.commerce.price({ min: 100, max: 1000 })),
                            percent: 10
                        }
                    },
                    inventoriesSummary: {
                        classicInventories: faker.number.int({ min: 0, max: 5 }),
                        digitalInventories: faker.number.int({ min: 1, max: 10 }),
                        packages: null
                    },
                    campaignInventories: Array.from({ length: 3 }, () => ({
                        id: faker.string.uuid(),
                        dsp: 'ECOMMERCE',
                        startDate: faker.date.future().toISOString().split('T')[0],
                        endDate: faker.date.future().toISOString().split('T')[0],
                        companyId: faker.string.uuid(),
                        inventoryName: faker.location.streetAddress(),
                        inventoryId: faker.string.uuid(),
                        inventoryReferenceId: `AUS-BIG-D-${faker.number.int({ min: 10000, max: 99999 })}`,
                        inventoryType: 'DIGITAL_BILLBOARD',
                        inventoryVenueType: getRandomElement(['Transit', 'Retail', 'Airport']),
                        inventoryThumbnailUrl: `${import.meta.env.VITE_APP_FOLDER_PATH.replace(/\/$/, '')}/${getRandomElement(sampleImages).replace(/^\//, '')}`,
                        inventoryPrice: parseFloat(faker.commerce.price({ min: 500, max: 5000 })),
                        inventoryLatitude: faker.location.latitude(),
                        inventoryLongitude: faker.location.longitude(),
                        isSpotBased: faker.datatype.boolean(),
                        inventoryReports: {
                            totalPotentialViews: faker.number.int({ min: 10000, max: 500000 }),
                            averageFrequency: parseFloat(faker.number.float({ min: 1, max: 10 }).toFixed(2)),
                            cpm: parseFloat(faker.number.float({ min: 1, max: 50 }).toFixed(2)),
                            totalReach: faker.number.int({ min: 5000, max: 100000 })
                        }
                    })),
                    agency: {
                        id: faker.string.uuid(),
                        name: faker.company.name()
                    },
                    company: {
                        id: faker.string.uuid(),
                        name: faker.company.name()
                    },
                    user: {
                        id: faker.string.uuid(),
                        name: faker.person.fullName()
                    },
                    summaryReport: {
                        potentialViews: faker.number.int({ min: 100000, max: 1000000 }),
                        uniqueReach: faker.number.int({ min: 50000, max: 500000 }),
                        cpm: parseFloat(faker.number.float({ min: 1, max: 20 }).toFixed(2)),
                        averageFrequency: parseFloat(faker.number.float({ min: 1, max: 10 }).toFixed(2)),
                        totalSpots: faker.number.int({ min: 100, max: 10000 })
                    },
                    reporting: {
                        proofOfPlay: true,
                        deliveryReports: true
                    },
                    buyerDetails: {
                        name: faker.person.fullName(),
                        companyName: faker.company.name(),
                        email: faker.internet.email(),
                        mobile: faker.phone.number(),
                        address: faker.location.streetAddress()
                    }
                },
                assets: Array.from({ length: 2 }, () => ({
                    id: faker.string.uuid(),
                    fileName: `payment_slip_${faker.number.int({ min: 1000, max: 9999 })}.pdf`,
                    filePath: `${import.meta.env.VITE_APP_FOLDER_PATH.replace(/\/$/, '')}/static/mockbillboard/sample1.jpg`,
                    duration: null,
                    resolution: null,
                    metadata: null,
                    createdDate: faker.date.recent().toISOString(),
                    lastModifiedDate: faker.date.recent().toISOString()
                }))
            }
        }
    };
    return mockData;
}

function getOfflinePaymentUploadMock() {
    const mockData = {
        data: {
            uploadOfflinePayment: {
                success: true,
                message: 'Mock upload successful',
                paymentId: faker.string.uuid(),
                assets: [
                    {
                        id: faker.string.uuid(),
                        fileName: `payment_receipt_${faker.number.int({ min: 1000, max: 9999 })}.jpg`,
                        filePath: `${import.meta.env.VITE_APP_FOLDER_PATH.replace(/\/$/, '')}/static/mockbillboard/sample1.jpg`
                    }
                ]
            }
        }
    };
    return mockData;
}

function getRegisterMutationMock() {
    return {
        data: {
            createUserOtp: {
                success: true,
                message: 'OTP sent successfully',
                id: faker.string.uuid(),
                email: faker.internet.email(),
                companyId: faker.string.uuid()
            }
        }
    };
}

function getCouponsMutationMock() {
    return {
        data: {
            validateCoupon: {
                couponData: {
                    success: true,
                    message: 'Coupon valid',
                    statusCode: 200,
                    discount: faker.number.int({ min: 5, max: 30 })
                }
            }
        }
    };
}

function getMediaIdMock() {
    return {
        data: {
            mediaOwnerByDomain: {
                mediaOwner: {
                    id: faker.string.uuid(),
                    domainName: faker.internet.domainName(),
                    mediaOwnerCompanyId: faker.string.uuid()
                }
            }
        }
    };
}

function getExplorePropertyVenueTypeListMock() {
    return {
        data: {
            venueTypes: Array.from({ length: 5 }, () => ({
                id: faker.string.uuid(),
                name: getRandomElement(['Transit', 'Retail', 'Airports', 'Shopping Malls', 'Office Buildings']),
                value: faker.lorem.word(),
                child: Array.from({ length: 3 }, () => ({
                    id: faker.string.uuid(),
                    name: faker.lorem.words(2),
                    value: faker.lorem.word(),
                    child: Array.from({ length: 2 }, () => ({
                        id: faker.string.uuid(),
                        name: faker.lorem.words(2),
                        value: faker.lorem.word()
                    }))
                }))
            }))
        }
    };
}

function getCountryListMock() {
    return {
        data: {
            countryList: Array.from({ length: 10 }, () => ({
                countryId: faker.string.uuid(),
                name: faker.location.country(),
                iso: faker.location.countryCode(),
                dialingCode: `+${faker.number.int({ min: 1, max: 999 })}`,
                id: faker.string.uuid(),
                currencyCode: faker.finance.currencyCode(),
                region: getRandomElement(['Asia', 'Europe', 'Americas', 'Oceania']),
                tax: {
                    label: getRandomElement(['GST', 'VAT', 'Sales Tax']),
                    percent: faker.number.int({ min: 5, max: 20 })
                }
            }))
        }
    };
}

function getMarketplaceCountriesMock() {
    return {
        data: {
            getMarketplaceCountries: Array.from({ length: 8 }, () => ({
                countryId: faker.string.uuid(),
                name: faker.location.country(),
                iso: faker.location.countryCode(),
                dialingCode: `+${faker.number.int({ min: 1, max: 999 })}`,
                id: faker.string.uuid(),
                currencyCode: faker.finance.currencyCode(),
                region: getRandomElement(['Asia', 'Europe', 'Americas']),
                tax: {
                    label: 'GST',
                    percent: faker.number.int({ min: 5, max: 15 })
                }
            }))
        }
    };
}

function getCountryByIpMock() {
    return {
        data: {
            getCountryByIp: {
                ipAddress: faker.internet.ipv4(),
                country: faker.location.country(),
                success: true,
                message: 'Country detected successfully'
            }
        }
    };
}

function getForgetPasswordMock() {
    return {
        data: {
            forgetPassword: {
                message: 'Password reset link sent to your email'
            }
        }
    };
}

function getMyCampaignListMock() {
    return getCampaignListData();
}

function getGetCampaignsMock() {
    return {
        data: {
            campaigns: Array.from({ length: 5 }, () => ({
                id: faker.string.uuid(),
                name: faker.commerce.productName(),
                status: getRandomElement(['ACTIVE', 'PENDING', 'COMPLETED'])
            }))
        }
    };
}

function getDeleteCartPageMock() {
    return {
        data: {
            deleteCartItem: {
                success: true,
                message: 'Items deleted successfully',
                statusCode: 200,
                deletedItems: faker.number.int({ min: 1, max: 5 })
            }
        }
    };
}

function getRequestForApprovalMock() {
    return {
        data: {
            requestForApproval: {
                campaign: {
                    id: faker.string.uuid(),
                    dealId: `DEAL-${faker.number.int({ min: 10000, max: 99999 })}`,
                    name: faker.commerce.productName(),
                    bookingSource: 'ONLINE',
                    startDate: faker.date.future().toISOString(),
                    endDate: faker.date.future().toISOString(),
                    campaignStatus: 'PENDING_APPROVAL'
                }
            }
        }
    };
}

function getMyCartItemListMock() {
    return {
        data: {
            mycartItemList: Array.from({ length: 4 }, () => ({
                id: faker.string.uuid(),
                group: faker.lorem.word(),
                resolutionWidth: faker.number.int({ min: 1280, max: 3840 }),
                thumbnailPath: `${import.meta.env.VITE_APP_FOLDER_PATH.replace(/\/$/, '')}/${getRandomElement(sampleImages).replace(/^\//, '')}`,
                fullResImagePath: `${import.meta.env.VITE_APP_FOLDER_PATH.replace(/\/$/, '')}/${getRandomElement(sampleImages).replace(/^\//, '')}`,
                resolutionHeight: faker.number.int({ min: 720, max: 2160 }),
                name: faker.location.streetAddress(),
                displayName: faker.company.name(),
                type: getRandomElement(['DIGITAL', 'STATIC']),
                sellingRate: {
                    monthly: {
                        month1: parseFloat(faker.commerce.price({ min: 500, max: 2000 }))
                    }
                },
                monthlySummary: {
                    id: faker.string.uuid(),
                    totalVisitors: faker.number.int({ min: 10000, max: 500000 }),
                    uniqueVisitors: faker.number.int({ min: 5000, max: 100000 }),
                    reach: faker.number.int({ min: 1000, max: 50000 }),
                    frequency: parseFloat(faker.number.float({ min: 1, max: 10 }).toFixed(2))
                }
            }))
        }
    };
}

function getAccountMock() {
    return {
        data: {
            userAccount: {
                id: faker.string.uuid(),
                email: faker.internet.email(),
                companyId: faker.string.uuid(),
                countryId: faker.string.uuid(),
                username: faker.internet.userName(),
                companyName: faker.company.name(),
                countryName: faker.location.country(),
                taxPercent: faker.number.int({ min: 5, max: 20 }),
                taxLabel: 'GST',
                dsp: faker.lorem.word(),
                latitude: faker.location.latitude(),
                longitude: faker.location.longitude(),
                firstName: faker.person.firstName(),
                lastName: faker.person.lastName()
            }
        }
    };
}

function getPropertyDetailsMock() {
    return getPropertyDetailsData();
}

function getContactUsMutationMock() {
    return {
        data: {
            contactUs: {
                status: 'SUCCESS'
            }
        }
    };
}

function getUploadContentMutationMock() {
    return {
        data: {
            uploadcontent: {
                success: true,
                message: 'Content uploaded successfully'
            }
        }
    };
}

function getDeleteContentMutationMock() {
    return {
        data: {
            deleteContent: {
                message: 'Content deleted successfully'
            }
        }
    };
}

function getAssignedContentCountMock() {
    return {
        data: {
            assignedContentCount: {
                count: faker.number.int({ min: 0, max: 50 }),
                id: faker.string.uuid()
            }
        }
    };
}

function getAssignedAssetsToCampaignMock() {
    return {
        data: {
            assignedAssetsToCampaign: Array.from({ length: 5 }, () => ({
                id: faker.string.uuid(),
                assetId: faker.string.uuid(),
                campaignId: faker.string.uuid(),
                fileName: `creative_${faker.number.int({ min: 1000, max: 9999 })}.mp4`,
                filePath: faker.internet.url()
            }))
        }
    };
}

function getNegotiateCampaignSendRequestMock() {
    return {
        data: {
            negotiate: {
                response: {
                    success: true,
                    statusCode: 200,
                    message: 'Negotiation request sent successfully',
                    id: faker.string.uuid()
                }
            }
        }
    };
}

function getChangePasswordMock() {
    return {
        data: {
            changePassword: {
                response: {
                    success: true,
                    message: 'Password changed successfully'
                }
            }
        }
    };
}

function getUpdateProfileMutationMock() {
    return {
        data: {
            updateUser: {
                message: 'Profile updated successfully'
            }
        }
    };
}

function getCartInitialQueryMock() {
    return {
        data: {
            cartpageItem: Array.from({ length: 3 }, () => ({
                id: faker.string.uuid(),
                userId: faker.string.uuid(),
                campaignName: faker.commerce.productName(),
                startDate: faker.date.future().toISOString().split('T')[0],
                endDate: faker.date.future().toISOString().split('T')[0],
                cartItemName: faker.location.streetAddress(),
                cartItemId: faker.string.uuid(),
                cartItemReferenceId: `REF-${faker.number.int({ min: 10000, max: 99999 })}`,
                cartItemDeviceId: faker.string.uuid(),
                cartItemType: getRandomElement(['DIGITAL', 'STATIC']),
                cartItemCountry: faker.location.country(),
                cartItemVenueType: getRandomElement(['Transit', 'Retail', 'Airport']),
                cartItemResolutions: `${faker.number.int({ min: 1280, max: 3840 })}x${faker.number.int({ min: 720, max: 2160 })}`,
                cartItemThumbnailUrl: `${import.meta.env.VITE_APP_FOLDER_PATH.replace(/\/$/, '')}/${getRandomElement(sampleImages).replace(/^\//, '')}`,
                cartItemLatitude: faker.location.latitude(),
                cartItemLongitude: faker.location.longitude(),
                availableBooking: faker.datatype.boolean(),
                nextAvailableDate: faker.date.future().toISOString().split('T')[0],
                spotsAvailability: faker.number.int({ min: 0, max: 100 }),
                clientsAvailability: faker.number.int({ min: 0, max: 100 })
            }))
        }
    };
}

function getCreateCheckoutSessionMock() {
    return {
        data: {
            createCheckoutSession: {
                id: faker.string.uuid(),
                url: faker.internet.url(),
                requiresAction: false,
                clientSecret: faker.string.alphanumeric(32),
                error: null
            }
        }
    };
}

function getUpdateStatusMutationMock() {
    return {
        data: {
            updateCampaignStatus: {
                success: true,
                message: 'Campaign status updated successfully'
            }
        }
    };
}

function getSubmitEnquiryMock() {
    return {
        data: {
            submitEnquiry: {
                message: 'Enquiry submitted successfully'
            }
        }
    };
}

function getChatbotAnswerMock() {
    return {
        data: {
            chatbotAnswer: {
                question: 'What is billboard advertising?',
                answer: 'Billboard advertising is a form of outdoor advertising that uses large-scale print advertisements to market products, services, or brands.'
            }
        }
    };
}

function getCountryCodeListMock() {
    return {
        data: {
            countryCodeList: Array.from({ length: 10 }, () => ({
                code: faker.location.countryCode(),
                country: faker.location.country(),
                currency: faker.finance.currencyName(),
                currencySymbol: faker.finance.currencySymbol(),
                ISO: faker.location.countryCode()
            }))
        }
    };
}

function getDailyDeliveryReportMock() {
    return {
        data: {
            campaignDeliveryReport: {
                reports: Array.from({ length: 7 }, () => ({
                    id: faker.string.uuid(),
                    adPlays: faker.number.int({ min: 100, max: 10000 }),
                    creativeNames: [faker.system.fileName(), faker.system.fileName()],
                    creativeTypes: ['VIDEO', 'IMAGE'],
                    dealId: `DEAL-${faker.number.int({ min: 10000, max: 99999 })}`,
                    playerName: faker.company.name(),
                    publisherName: faker.company.name(),
                    firstPlayDate: faker.date.past().toISOString(),
                    lastPlayDate: faker.date.recent().toISOString(),
                    deliveryGoal: faker.number.int({ min: 1000, max: 50000 })
                }))
            }
        }
    };
}

function getDetailedDeliveryReportMock() {
    return {
        data: {
            campaignDeliveryReport: {
                reports: Array.from({ length: 20 }, () => ({
                    id: faker.string.uuid(),
                    adPlays: faker.number.int({ min: 1, max: 100 }),
                    creativeNames: [faker.system.fileName()],
                    creativeTypes: [getRandomElement(['VIDEO', 'IMAGE'])],
                    creativeDuration: faker.number.int({ min: 5, max: 30 }),
                    dealId: `DEAL-${faker.number.int({ min: 10000, max: 99999 })}`,
                    playerName: faker.company.name(),
                    publisherName: faker.company.name(),
                    firstPlayDate: faker.date.recent().toISOString(),
                    lastPlayDate: faker.date.recent().toISOString(),
                    deliveryGoal: faker.number.int({ min: 100, max: 5000 }),
                    startTime: faker.date.recent().toISOString(),
                    endTime: faker.date.recent().toISOString(),
                    userAgent: faker.internet.userAgent(),
                    timezone: faker.location.timeZone(),
                    country: faker.location.country(),
                    city: faker.location.city(),
                    ipAddress: faker.internet.ipv4()
                })),
                totalPage: 5
            }
        }
    };
}

function getMediaOwnerFilterMock() {
    return {
        data: {
            mediaOwnerNameToken: Array.from({ length: 10 }, () => ({
                id: faker.string.uuid(),
                name: faker.company.name()
            }))
        }
    };
}

function getCompanyListMock() {
    return {
        data: {
            companyList: Array.from({ length: 15 }, () => ({
                id: faker.string.uuid(),
                name: faker.company.name()
            }))
        }
    };
}

function getEcommerceConfigMock() {
    return {
        data: {
            ecommerceConfig: {
                paymentIntegrationConfig: {
                    provider: 'STRIPE',
                    accessKey: faker.string.alphanumeric(32)
                }
            }
        }
    };
}

function getStateListMarketplaceMock() {
    return {
        data: {
            stateListMarketplace: Array.from({ length: 10 }, () => ({
                stateId: faker.string.uuid(),
                name: faker.location.state()
            }))
        }
    };
}

function getDistrictListMarketplaceMock() {
    return {
        data: {
            districtListMarketplace: Array.from({ length: 12 }, () => ({
                id: faker.string.uuid(),
                districtId: faker.string.uuid(),
                name: faker.location.county(),
                __typename: 'District'
            }))
        }
    };
}

function getDistrictList() {
    const mockData = {
        data: {
            districtList: Array.from({ length: 10 }, () => ({
                districtId: faker.string.uuid(),
                name: faker.location.state(),
            }))
        }
    }
    return mockData;
}

function generateLocationBaseMockData() {
    return {
        id: faker.string.uuid(),
        name: faker.location.city(),
        nameJa: faker.location.city(),
        latitude: faker.location.latitude(),
        longitude: faker.location.longitude(),
        zoom: faker.number.int({ min: 4, max: 12 }),
        swLat: faker.location.latitude(),
        swLng: faker.location.longitude(),
        seLat: faker.location.latitude(),
        seLng: faker.location.longitude(),
        neLat: faker.location.latitude(),
        neLng: faker.location.longitude(),
        nwLat: faker.location.latitude(),
        nwLng: faker.location.longitude(),
        population: faker.number.int({ min: 1000, max: 1000000 }),
        iso: faker.location.countryCode(),
        locale: 'en'
    };
}

// Mock function for CREATE_PAYMENT_METHOD
function getCreatePaymentMethodMock() {
    return {
        data: {
            createPaymentMethod: {
                success: true,
                statusCode: 200,
                message: "Your BNPL application has been submitted successfully. Our team will review your application and get back to you within 24-48 hours.",
                paymentId: faker.string.uuid(),
                paymentType: "OFFLINE_BNPL",
                campaignName: faker.company.catchPhrase(),
                __typename: "CreatePaymentMethodResponse"
            }
        }
    };
}

// Mock function for CREATE_PAYMENT_INTENT
function getCreatePaymentIntentMock() {
    // Generate a mock client secret that looks realistic for Stripe
    const mockClientSecret = `pi_${faker.string.alphanumeric(24)}_secret_${faker.string.alphanumeric(24)}`;
    
    return {
        data: {
            createPaymentIntent: {
                clientSecret: mockClientSecret,
                code: 200,
                message: "Payment intent created successfully",
                __typename: "CreatePaymentIntentResponse"
            }
        }
    };
}

// Map queries to mock data functions
const mutationMapper: { [key: string]: Function } = {
    "EXPLORE_PROPERTY_BUTTON": getLandingPageData,
    "MY_CAMPAIGN_LIST_QUERY": getCampaignListData,
    "CONTENT_HUB_QUERY": getContentHubData,
    "DELIVERY_REPORTS_QUERY": getDeliveryReportData,
    "INVOICE": getInvoiceData,
    "CART_PAGE_ITEM": getCartItemData,
    "GETPROPERTY_LIST": getPropertyListData,
    "PROPERTY_DETAILS": getPropertyDetailsData,
    "PROPERTY_DETAILS_CHART_QUERY": getBubbleData,
    "GET_MY_CART_ITEMS": getCartDetails,
    "PROOF_OF_PLAY": getProofOfPlayData,
    "PROOF_OF_PLAY_ASSERTS": getProofOfPlayAssets,
    "ASSIGN_CREATIVES_ITEM_QUERY": getAssignCreativeItem,
    "GET_ASSIGNED_CONTENT": getAssignedContent,
    "GET_ASSIGN_ECOMMERCE_ASSETS": getEcommerceAssetsData,
    "EDIT_CAMPAIGN": getEditCartItemData,
    "NEGOTIATE_CAMPAIGN_QUERY": getNegotiateCampaignData,
    "Get_Country_Code": getCountryCodeData,
    "Get_Currency_Code_Details": getCurrencyCodeData,
    "USER_ACCOUNT_QUERY": userData,
    "AUTHENTICATE_MUTATION": authenticate,
    "Get_ThreeBillboard": GetThreeBillboard,
    "GALLERY_IMAGE_ASSETS_QUERY": GetGalleryImageInDetails,
    "GET_LANDING_EXPLORATION": getExplorePropertyListData,
    "PROPERTY_LIST_VENUE_TYPE_LIST": getVenueTypeListData,
    "GET_STATE_LIST": getStateList,
    "GET_DISTRICT_LIST": getDistrictList,
    "COMPANY_PAYMENT_OPTIONS": getCompanyPaymentOptionsMock,
    "PAYMENT_TRANSACTION_DETAILS": getPaymentTransactionDetailsMock,
    "GET_OFFLINE_PAYMENT_INVOICE": getOfflinePaymentInvoiceMock,
    "OFFLINE_PAYMENT_UPLOAD_MUTATION": getOfflinePaymentUploadMock,
    "REGISTER_MUTATION": getRegisterMutationMock,
    "COUPONS_MUTATION": getCouponsMutationMock,
    "Media_Id": getMediaIdMock,
    "EXPLORE_PROPERTY_VENUE_TYPE_LIST": getExplorePropertyVenueTypeListMock,
    "GET_COUNTRY_LIST": getCountryListMock,
    "GET_MARKETPLACE_COUNTRIES": getMarketplaceCountriesMock,
    "GET_COUNTRY_BY_IP": getCountryByIpMock,
    "FORGET_PASSWORD": getForgetPasswordMock,
    "MYCAMPAIGN_LIST": getMyCampaignListMock,
    "GET_CAMPAIGNS": getGetCampaignsMock,
    "DELETE_CART_PAGE": getDeleteCartPageMock,
    "REQUEST_FOR_APPROVAL": getRequestForApprovalMock,
    "MY_CART_ITEM_LIST": getMyCartItemListMock,
    "ACCOUNT": getAccountMock,
    "GET_PROPERTY_DETAILS": getPropertyDetailsMock,
    "CONTACT_US_MUTATION": getContactUsMutationMock,
    "UPLOAD_CONTENT_MUTATION": getUploadContentMutationMock,
    "DELETE_CONTENT_MUTATION": getDeleteContentMutationMock,
    "ASSIGNED_CONTENT_COUNT": getAssignedContentCountMock,
    "ASSIGNED_ASSETS_TOCAMPAIGN": getAssignedAssetsToCampaignMock,
    "NEGOTIATE_CAMPAIGN_SEND_REQUEST": getNegotiateCampaignSendRequestMock,
    "CHANGE_PASSWORD": getChangePasswordMock,
    "UPDATE_PROFILE_MUTATION": getUpdateProfileMutationMock,
    "CART_INITIAL_QUERY": getCartInitialQueryMock,
    "CREATE_CHECKOUT_SESSION": getCreateCheckoutSessionMock,
    "UPDATESTATUSMUTATION": getUpdateStatusMutationMock,
    "SUBMIT_ENQUIRY": getSubmitEnquiryMock,
    "CHATBOT_ANSWER": getChatbotAnswerMock,
    "COUNTRY_CODE_LIST": getCountryCodeListMock,
    "GET_DAILY_DELIVERY_REPORT": getDailyDeliveryReportMock,
    "GET_DETAILED_DELIVERY_REPORT": getDetailedDeliveryReportMock,
    "MEDIA_OWNER_FILTER": getMediaOwnerFilterMock,
    "COMPANY_LIST": getCompanyListMock,
    "ECOMMERCE_CONFIG": getEcommerceConfigMock,
    "GET_STATE_LIST_MARKETPLACE": getStateListMarketplaceMock,
    "GET_DISTRICT_LIST_MARKETPLACE": getDistrictListMarketplaceMock,
    "CREATE_PAYMENT_METHOD": getCreatePaymentMethodMock,
    "CREATE_PAYMENT_INTENT": getCreatePaymentIntentMock,
};

// Define a function to get the identifier based on the query structure
const getQueryIdentifier = (query: any): string => {
    if (query === EXPLORE_PROPERTY_BUTTON) return "EXPLORE_PROPERTY_BUTTON";
    if (query === MY_CAMPAIGN_LIST_QUERY) return "MY_CAMPAIGN_LIST_QUERY";
    if (query === CONTENT_HUB_QUERY) return "CONTENT_HUB_QUERY";
    if (query === DELIVERY_REPORTS_QUERY) return "DELIVERY_REPORTS_QUERY";
    if (query === INVOICE) return "INVOICE";
    if (query === CART_PAGE_ITEM) return "CART_PAGE_ITEM";
    if (query === GETPROPERTY_LIST) return "GETPROPERTY_LIST";
    if (query === PROPERTY_DETAILS) return "PROPERTY_DETAILS";
    if (query === PROPERTY_DETAILS_CHART_QUERY) return "PROPERTY_DETAILS_CHART_QUERY";
    if (query === GET_MY_CART_ITEMS) return "GET_MY_CART_ITEMS";
    if (query === PROOF_OF_PLAY) return "PROOF_OF_PLAY";
    if (query === PROOF_OF_PLAY_ASSERTS) return "PROOF_OF_PLAY_ASSERTS";
    if (query === ASSIGN_CREATIVES_ITEM_QUERY) return "ASSIGN_CREATIVES_ITEM_QUERY";
    if (query === GET_ASSIGNED_CONTENT) return "GET_ASSIGNED_CONTENT";
    if (query === GET_ASSIGN_ECOMMERCE_ASSETS) return "GET_ASSIGN_ECOMMERCE_ASSETS";
    if (query === EDIT_CAMPAIGN) return "EDIT_CAMPAIGN";
    if (query === NEGOTIATE_CAMPAIGN_QUERY) return "NEGOTIATE_CAMPAIGN_QUERY";
    if (query === Get_Country_Code) return "Get_Country_Code";
    if (query === Get_Currency_Code_Details) return "Get_Currency_Code_Details";
    if (query === USER_ACCOUNT_QUERY) return "USER_ACCOUNT_QUERY";
    if (query === AUTHENTICATE_MUTATION) return "AUTHENTICATE_MUTATION";
    if (query === Get_ThreeBillboard) return "Get_ThreeBillboard";
    if (query === GALLERY_IMAGE_ASSETS_QUERY) return "GALLERY_IMAGE_ASSETS_QUERY";
    if (query === GET_LANDING_EXPLORATION) return "GET_LANDING_EXPLORATION";
    if (query === PROPERTY_LIST_VENUE_TYPE_LIST) return "PROPERTY_LIST_VENUE_TYPE_LIST";
    if (query === GET_STATE_LIST) return "GET_STATE_LIST";
    if (query === GET_DISTRICT_LIST) return "GET_DISTRICT_LIST";
    if (query === COMPANY_PAYMENT_OPTIONS) return "COMPANY_PAYMENT_OPTIONS";
    if (query === PAYMENT_TRANSACTION_DETAILS) return "PAYMENT_TRANSACTION_DETAILS";
    if (query === GET_OFFLINE_PAYMENT_INVOICE) return "GET_OFFLINE_PAYMENT_INVOICE";
    if (query === OFFLINE_PAYMENT_UPLOAD_MUTATION) return "OFFLINE_PAYMENT_UPLOAD_MUTATION";
    if (query === REGISTER_MUTATION) return "REGISTER_MUTATION";
    if (query === COUPONS_MUTATION) return "COUPONS_MUTATION";
    if (query === Media_Id) return "Media_Id";
    if (query === EXPLORE_PROPERTY_VENUE_TYPE_LIST) return "EXPLORE_PROPERTY_VENUE_TYPE_LIST";
    if (query === GET_COUNTRY_LIST) return "GET_COUNTRY_LIST";
    if (query === GET_MARKETPLACE_COUNTRIES) return "GET_MARKETPLACE_COUNTRIES";
    if (query === GET_COUNTRY_BY_IP) return "GET_COUNTRY_BY_IP";
    if (query === FORGET_PASSWORD) return "FORGET_PASSWORD";
    if (query === MYCAMPAIGN_LIST) return "MYCAMPAIGN_LIST";
    if (query === GET_CAMPAIGNS) return "GET_CAMPAIGNS";
    if (query === DELETE_CART_PAGE) return "DELETE_CART_PAGE";
    if (query === REQUEST_FOR_APPROVAL) return "REQUEST_FOR_APPROVAL";
    if (query === MY_CART_ITEM_LIST) return "MY_CART_ITEM_LIST";
    if (query === ACCOUNT) return "ACCOUNT";
    if (query === GET_PROPERTY_DETAILS) return "GET_PROPERTY_DETAILS";
    if (query === CONTACT_US_MUTATION) return "CONTACT_US_MUTATION";
    if (query === UPLOAD_CONTENT_MUTATION) return "UPLOAD_CONTENT_MUTATION";
    if (query === DELETE_CONTENT_MUTATION) return "DELETE_CONTENT_MUTATION";
    if (query === ASSIGNED_CONTENT_COUNT) return "ASSIGNED_CONTENT_COUNT";
    if (query === ASSIGNED_ASSETS_TOCAMPAIGN) return "ASSIGNED_ASSETS_TOCAMPAIGN";
    if (query === NEGOTIATE_CAMPAIGN_SEND_REQUEST) return "NEGOTIATE_CAMPAIGN_SEND_REQUEST";
    if (query === CHANGE_PASSWORD) return "CHANGE_PASSWORD";
    if (query === UPDATE_PROFILE_MUTATION) return "UPDATE_PROFILE_MUTATION";
    if (query === CART_INITIAL_QUERY) return "CART_INITIAL_QUERY";
    if (query === CREATE_CHECKOUT_SESSION) return "CREATE_CHECKOUT_SESSION";
    if (query === UPDATESTATUSMUTATION) return "UPDATESTATUSMUTATION";
    if (query === SUBMIT_ENQUIRY) return "SUBMIT_ENQUIRY";
    if (query === CHATBOT_ANSWER) return "CHATBOT_ANSWER";
    if (query === COUNTRY_CODE_LIST) return "COUNTRY_CODE_LIST";
    if (query === GET_DAILY_DELIVERY_REPORT) return "GET_DAILY_DELIVERY_REPORT";
    if (query === GET_DETAILED_DELIVERY_REPORT) return "GET_DETAILED_DELIVERY_REPORT";
    if (query === MEDIA_OWNER_FILTER) return "MEDIA_OWNER_FILTER";
    if (query === COMPANY_LIST) return "COMPANY_LIST";
    if (query === ECOMMERCE_CONFIG) return "ECOMMERCE_CONFIG";
    if (query === GET_STATE_LIST_MARKETPLACE) return "GET_STATE_LIST_MARKETPLACE";
    if (query === GET_DISTRICT_LIST_MARKETPLACE) return "GET_DISTRICT_LIST_MARKETPLACE";
    if (query === CREATE_PAYMENT_METHOD) return "CREATE_PAYMENT_METHOD";
    if (query === CREATE_PAYMENT_INTENT) return "CREATE_PAYMENT_INTENT";
    return "";
};

export const generateMockData = (query: any) => {
    const queryIdentifier = getQueryIdentifier(query); // Get the identifier


    if (mutationMapper.hasOwnProperty(queryIdentifier)) {
        const mockData = mutationMapper[queryIdentifier](); // Call the corresponding function
        return Promise.resolve(mockData); // Return the resolved mock data
    }
    // Return null if no mock data is found for the query
    return Promise.resolve(null);
};
